// import ShadowOnlyMaterial from 'babylonjs-materials';
import jQuery from 'jquery';
import earcut from 'earcut';

const $ = jQuery;

// BABYLON.Tools.BaseUrl = texturesUrl;

var onPointerClick = function (e) {
  var result = window.scene.pick(window.scene.pointerX, window.scene.pointerY, null, null, window.scene.activeCamera);
  if (result.hit) {
    console.log(result.pickedMesh.name);
    if (document.getElementById('mesh-name') !== null) {
      document.getElementById('mesh-name').textContent = result.pickedMesh.name;
    }
  }
};
document.getElementById('renderCanvas').addEventListener('pointerdown', onPointerClick, false);
!(function ($) {
  var PDWGL = ($.printqDetectWebGL = () => { });
  $.extend(PDWGL, {
    defaults: {
      canvas: '#renderCanvas',
    },
    _O: function (o) {
      return $.extend({}, PDWGL.defaults, o);
    },
    init: () => {
      var o = PDWGL._O(o);
      if (!PDWGL.detectWebGl(o)) {
        return false;
      }
      return true;
    },
    detectWebGl: function () {
      var webGLCanvas = document.createElement('canvas');
      if (!!WebGLRenderingContext) {
        try {
          var value = !!WebGLRenderingContext && (webGLCanvas.getContext('webgl') || webGLCanvas.getContext('experimental-webgl'));
          webGLCanvas.remove();
          return value;
        } catch (e) {
          return false;
        }
      }
      return false;
    },
  });
})(jQuery);

var webGlEnabled = jQuery.printqDetectWebGL.init();
if (webGlEnabled) {
  var _scene;

  var animation_running = 0;
  var onMessageStorage = '';
  var loaded = false;

  // Building variables
  var meshesParents = [];
  var curves_count = 0;
  var axisPoints = [];
  var puncte_finale_sus = [];
  var puncte_finale_jos = [];
  var puncte_finale_sides = [];
  var name_array = [];
  var curve_parent = [];
  var uvsCurve = [];
  var toBuild_no_y = [];
  var min_x = 99999;
  var min_y = 99999;
  var max_x = -99999;
  var max_y = -99999;
  var points = [];
  var prevPoints = [];
  var curvePoints = [];
  var sideMeshes = [];
  var small_area_points = [];

  // Materials
  var CartonMaterial;
  var FaceMaterial;
  var BackMaterial;

  // Model config
  var STANDARD_MODEL = true;
  var thickness = parseFloat(Engine3DVariables.thickness); // get thickness
  var fluteType = 'default';
  var enableHighlight = false;
  var enableMeshFocus = false;
  var lastHighlightedMesh = null;

  // Model optimize
  var curveSides = [];

  // Camera config
  var arcCamera;
  var old_max_x = 0;
  var old_max_y = 0;
  var old_min_x = 0;
  var old_min_y = 0;
  var tmp = 1;
  var buffer = null;
  var ssAttr = {
    stage: 0,
    camera: {
      radius: 600,
      alpha: 4.05,
      beta: 0.92,
      target: new BABYLON.Vector3(0, 0, 0),
    },
    bg: new BABYLON.Color4(0, 0, 0, 0),
  };

  var posAnimation_running = 0;
  var cameraAnimation_running = false;
  var cachedModelData = null;

  Math.easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  var BabylonModel = function (canvas, model) {
    this.model = model;
    this.engine = new BABYLON.Engine(canvas, true);

    // Resize window event
    var _this = this;

    window.addEventListener('resize', function () {
      _this.engine.resize();
    });

    var loadingScreen = new MyLoadingScreen("I'm loading!!");
    //Set the loading screen in the engine to replace the default one
    this.engine.loadingScreen = loadingScreen;

    return this;
  };

  BabylonModel.prototype.startScene = function (cb) {
    this.model.data = this.model.close_data;
    BABYLON.SceneLoader.Load(texturesUrl, 'data:' + this.model.data, this.engine, (scene) => {
      this.scene = scene;
      window.scene = scene;
      _scene = scene;
      $.ajax({
        type: 'GET',
        url: Engine3DVariables.getPointsUrl,
      }).done((data) => {
        _scene.multiMaterials = [];
        _scene.meshes = [];
        points = JSON.parse(data);
        prevPoints = points;
        setFluteType(Engine3DVariables.fluteType);
        createMyMaterials(() => {
          if (STANDARD_MODEL == true) {
            createMeshesStandard();
            createMeshesCopyStandard();
            if (fluteType !== 'default' && Engine3DVariables.enableCorrugation === 1) {
              corrugatedBoard();
            } else {
              createSidesStandard();
            }
            createParentsStandard();
            createPivotAxisStandard();
            cb();
          } else if (STANDARD_MODEL == false) {
            createAxisPointsAdvanced();
            createMeshesAdvanced();
            createMeshesCopyAdvanced();
            createCurveAdvanced();
            createParentsAdvanced();
            createPivotAxisAdvanced();
            if (fluteType !== 'default' && Engine3DVariables.enableCorrugation === 1) {
              corrugatedBoard();
            } else {
              createSidesAdvanced();
            }
            cb();
          }
        });
      });

      //add texture to mug
      let extra = scene.getMeshByName('Extra');
      if (extra !== null) {
        extra.material.diffuseTexture = new BABYLON.Texture(texturesUrl + 'logo.png', _scene, undefined, undefined, BABYLON.Texture.NEAREST_NEAREST);
      }

      scene.executeWhenReady(() => {
        this.engine.runRenderLoop(() => {
          this.scene.render();
        });
      });
    });
  };

  BabylonModel.prototype.initScene = function () {
    this.scene.clearColor = new BABYLON.Color4(0.1, 0.1, 0.1, 0.1);
    this.initCamera();
    this.initLights();
  };

  BabylonModel.prototype.initGlassMat = function (meshName) {
    for (var index in this.scene.meshes) {
      if (this.scene.meshes[index].name == meshName) {
        var hdrTexture = new BABYLON.HDRCubeTexture('white.hdr', this.scene, 128);
        var glass = new BABYLON.PBRMaterial('glass', this.scene);
        glass.reflectionTexture = hdrTexture;
        glass.indexOfRefraction = 0.52;
        glass.alpha = 0.5;
        glass.directIntensity = 0.0;
        glass.environmentIntensity = 0.7;
        glass.cameraExposure = 1.66;
        glass.cameraContrast = 1.66;
        glass.microSurface = 1;
        glass.reflectivityColor = new BABYLON.Color3(0.2, 0.2, 0.2);
        glass.albedoColor = new BABYLON.Color3(0.95, 0.95, 0.95);
        this.scene.meshes[index].material = glass;
      }
    }
  };

  BabylonModel.prototype.initCamera = function () {
    arcCamera = new BABYLON.ArcRotateCamera('ArcRotateCamera', 0, 0, 0, new BABYLON.Vector3(0, 0, 0), this.scene);
    arcCamera.setPosition(this.scene.activeCamera.position);

    if (max_x > max_y) {
      arcCamera.upperRadiusLimit = max_x + max_x * 2;
      arcCamera.radius = max_x;
    } else if (max_x <= max_y) {
      arcCamera.upperRadiusLimit = max_y + max_y * 2;
      arcCamera.radius = max_y;
    }

    if (min_x > min_y) {
      arcCamera.lowerRadiusLimit = min_x;
    } else if (min_x <= min_y) {
      arcCamera.lowerRadiusLimit = min_y;
    }

    for (var name in Engine3DVariables.meshes) {
      if (name == Engine3DVariables.cameraSettings.cameraCenter) {
        buffer = name;
        break;
      }
    }

    for (var i = 0; i < name_array.length; i++) {
      if (buffer == name_array[i]) {
        buffer = i;
        break;
      }
    }

    if (Engine3DVariables.cameraSettings.cameraCenter.length > 0) {
      var local_x = _scene.meshes[buffer].getBoundingInfo().boundingBox.minimumWorld.x;
      var local_y = _scene.meshes[buffer].getBoundingInfo().boundingBox.minimumWorld.y;
      var local_z = _scene.meshes[buffer].getBoundingInfo().boundingBox.minimumWorld.z;

      var global_x = _scene.meshes[buffer].getBoundingInfo().boundingBox.maximumWorld.x;
      var global_y = _scene.meshes[buffer].getBoundingInfo().boundingBox.maximumWorld.y;
      var global_z = _scene.meshes[buffer].getBoundingInfo().boundingBox.maximumWorld.z;

      arcCamera.target.x = (local_x + global_x) / 2;
      arcCamera.target.y = (local_y + global_y) / 2;
      arcCamera.target.z = (local_z + global_z) / 2;
    } else if (Engine3DVariables.cameraSettings.cameraCenter.length == 0) {
      arcCamera.target.x = eval(Engine3DVariables.cameraSettings.cameraTargetAdj.x);
      arcCamera.target.y = eval(Engine3DVariables.cameraSettings.cameraTargetAdj.y);
      arcCamera.target.z = eval(Engine3DVariables.cameraSettings.cameraTargetAdj.z);
    }
    if (typeof Engine3DVariables.cameraSettings.cameraPosition != 'undefined') {
      var poz = new BABYLON.Vector3(Engine3DVariables.cameraSettings.cameraPosition.x, Engine3DVariables.cameraSettings.cameraPosition.y, Engine3DVariables.cameraSettings.cameraPosition.z);
      arcCamera.setPosition(poz);
    }

    arcCamera.attachControl(this.engine.getRenderingCanvas(), false);
    this.scene.activeCamera = arcCamera;

    for (var index in _scene.meshes) {
      if (_scene.meshes[index].name == 'Extra') {
        MugPosition = new BABYLON.Vector3(x, 2, z);
        _scene.meshes[index].position = MugPosition;
      }
    }

    arcCamera.panningSensibility = 50;
    arcCamera.wheelPrecision = 1;
  };

  BabylonModel.prototype.initLights = function () {
    scene.lights = [];

    let env = BABYLON.CubeTexture.CreateFromPrefilteredData("../packing_textures/studio.env", scene);
    scene.environmentTexture = env;
    scene.environmentIntensity = 1;

    //used for shadow only
    var light = new BABYLON.DirectionalLight("shadow", new BABYLON.Vector3(120, -140, 120), this.scene);
    light.position = new BABYLON.Vector3(-120, 140, -120);
    light.intensity = 0.1;

    //used for specularity - front
    var light2 = new BABYLON.DirectionalLight("front", new BABYLON.Vector3(-1, -1, 20), this.scene);
    light2.position = arcCamera.target;
    light2.intensity = 0.1;

    //used for specularity - back
    var light3 = new BABYLON.DirectionalLight("back", new BABYLON.Vector3(1, 1, -20), this.scene);
    light3.position = arcCamera.target;
    light3.intensity = 0.1;

    //used for specularity - left
    var light4 = new BABYLON.DirectionalLight("left", new BABYLON.Vector3(-20, 1, 1), this.scene);
    light4.position = arcCamera.target;
    light4.intensity = 0.1;

    //used for specularity - right
    var light5 = new BABYLON.DirectionalLight("right", new BABYLON.Vector3(20, -1, -1), this.scene);
    light5.position = arcCamera.target;
    light5.intensity = 0.1;

    //used for specularity - top
    var light6 = new BABYLON.DirectionalLight("top", new BABYLON.Vector3(-1, 20, -1), this.scene);
    light6.position = arcCamera.target;
    light6.intensity = 0.1;

    //used for specularity - bottom
    var light7 = new BABYLON.DirectionalLight("bottom", new BABYLON.Vector3(1, -20, 1), this.scene);
    light7.position = arcCamera.target;
    light7.intensity = 0.1;

    //ambient lighting
    var light4 = new BABYLON.HemisphericLight("hemi", new BABYLON.Vector3(0, 1, 0), this.scene);
    light4.position = arcCamera.target;
    light4.groundColor = new BABYLON.Color3(0, 0, 0);
    light4.direction = new BABYLON.Vector3(-1, 1, -1);
    light4.intensity = 0.5;

    var ground = BABYLON.Mesh.CreatePlane('ground', 6000, this.scene);
    ground.rotation.x = Math.PI / 2;
    ground.material = new BABYLON.ShadowOnlyMaterial('mat', this.scene);
    ground.material.backFaceCulling = true;
    ground.isPickable = false;

    ground.position.y = eval(Engine3DVariables.cameraSettings.ground);
    for (var meshName in Engine3DVariables.meshes) {
      if (typeof Engine3DVariables.meshes[meshName].ground !== 'undefined') {
        ground.position.y = Engine3DVariables.meshes[meshName].ground;
      }
    }

    var shadowGenerator = new BABYLON.ShadowGenerator(1024, light);
    shadowGenerator.useBlurVarianceShadowMap = true;
    shadowGenerator.blurScale = 2;
    shadowGenerator.setDarkness(0.95);
    this.scene.meshes.forEach(function (mesh) {
      if (mesh.name != "ground") {
        mesh.receiveShadows = false;
        shadowGenerator.getShadowMap().renderList.push(mesh);
      }
    });
    ground.receiveShadows = true;


    BackMaterial.build();
    FaceMaterial.build();
    CartonMaterial.build();
  };

  BabylonModel.prototype.animation = function (stage, animValues, params) {
    _scene = this.scene;
    var reverse = 0;
    var noAnimation = 0;
    if (typeof params != 'undefined') {
      if (params.hasOwnProperty('reverse')) reverse = params.reverse;
      if (params.hasOwnProperty('noAnimation')) noAnimation = params.noAnimation;
    }
    var list = new Array();
    var positionList = new Array();
    if (!reverse) {
      var currentList = animValues[stage];
      if (typeof animValues[stage - 1] != 'undefined') {
        var previousList = animValues[stage - 1];
      }
      for (var step in currentList) {
        for (var meshName in currentList[step]['Rotation']) {
          if (typeof currentList[step]['Rotation'][meshName] != 'undefined' || typeof currentList[step]['Rotation'][meshName]['end'] != 'undefined') {
            //rotation
            if (step == 0) {
              if (typeof previousList == 'undefined') {
                var startAng = '0';
              } else {
                var startAng = previousList[previousList.length - 1]['Rotation'][meshName]['end'];
              }
              var obj = {
                meshName: meshName,
                startAngle: startAng,
                endAngle: currentList[step]['Rotation'][meshName]['end'],
              };
            } else {
              var obj = {
                meshName: meshName,
                startAngle: currentList[step - 1]['Rotation'][meshName]['end'],
                endAngle: currentList[step]['Rotation'][meshName]['end'],
              };
            }
            if (noAnimation) {
              obj['noAnimation'] = 1;
            }
            if (typeof list[step] == 'undefined') {
              list[step] = [];
              list[step]['rotation'] = new Array();
            }
            list[step]['rotation'].push(obj);
          }
        }
        for (var meshName in currentList[step]['Position']) {
          if (typeof currentList[step]['Position'][meshName] != 'undefined' || typeof currentList[step]['Position'][meshName]['position'] != 'undefined') {
            if (step == 0) {
              if (typeof previousList == 'undefined') {
                var startPos = animValues[0][0]['Position'][meshName];
              } else {
                var startPos = previousList[previousList.length - 1]['Position'][meshName];
              }
              var obj = {
                meshName: meshName,
                startPosition: startPos,
                endPos: currentList[step]['Position'][meshName],
              };
            } else {
              var obj = {
                meshName: meshName,
                startPosition: currentList[step - 1]['Position'][meshName],
                endPos: currentList[step]['Position'][meshName],
              };
            }
            if (noAnimation) {
              obj['noAnimation'] = 1;
            }
            if (typeof positionList[step] == 'undefined') {
              positionList[step] = [];
              positionList[step]['position'] = new Array();
            }
            positionList[step]['position'].push(obj);
          }
        }
      }
    } else {
      var previousList = animValues[stage];
      var currentList = animValues[stage + 1];
      var end = currentList.length - 2; //start from step-1
      for (var step = end; step >= 0; step--) {
        for (var meshName in currentList[step]['Rotation']) {
          var obj = {
            meshName: meshName,
            startAngle: currentList[step + 1]['Rotation'][meshName]['end'],
            endAngle: currentList[step]['Rotation'][meshName]['end'],
          };
          if (noAnimation) {
            obj['noAnimation'] = 1;
          }
          if (typeof list[step + 1] === 'undefined') {
            list[step + 1] = [];
            list[step + 1]['rotation'] = new Array();
          }
          list[step + 1]['rotation'].push(obj);
        }
        for (var meshName in currentList[step]['Position']) {
          var obj = {
            meshName: meshName,
            startPosition: currentList[step + 1]['Position'][meshName],
            endPos: currentList[step]['Position'][meshName],
          };
          if (noAnimation) {
            obj['noAnimation'] = 1;
          }
          if (typeof positionList[step + 1] === 'undefined') {
            positionList[step + 1] = [];
            positionList[step + 1]['position'] = new Array();
          }
          positionList[step + 1]['position'].push(obj);
        }
      }
      //add step to previous stage
      for (meshName in previousList[previousList.length - 1]['Rotation']) {
        obj = {
          meshName: meshName,
          startAngle: currentList[0]['Rotation'][meshName]['end'],
          endAngle: previousList[previousList.length - 1]['Rotation'][meshName]['end'],
        };
        if (noAnimation) {
          obj['noAnimation'] = 1;
        }
        if (typeof list[0] == 'undefined') {
          list[0] = [];
          list[0]['rotation'] = new Array();
        }
        list[0]['rotation'].push(obj);
      }
      for (meshName in previousList[previousList.length - 1]['Position']) {
        obj = {
          meshName: meshName,
          startPosition: currentList[0]['Position'][meshName],
          endPos: previousList[previousList.length - 1]['Position'][meshName],
        };
        if (noAnimation) {
          obj['noAnimation'] = 1;
        }
        if (typeof positionList[0] == 'undefined') {
          positionList[0] = [];
          positionList[0]['position'] = new Array();
        }
        positionList[0]['position'].push(obj);
      }
    }

    var deactivateButtons = function () {
      if (!animation_running && !posAnimation_running) {
        $('.animation-button').css({ pointerEvents: 'auto' });
      }
    };

    var animateMesh = function (meshData, noAnimation, stop) {
      animation_running = 1;
      var mesh = scene.getMeshByName(meshData['meshName']);
      var axis = new BABYLON.Vector3(Engine3DVariables.meshes[mesh.name].axis.quaternion[0], Engine3DVariables.meshes[mesh.name].axis.quaternion[1], Engine3DVariables.meshes[mesh.name].axis.quaternion[2]);
      var sA = eval(meshData['startAngle']);
      var eA = eval(meshData['endAngle']);
      var c = eA - sA;
      var fps = 50;
      var t = 0;
      var b = sA;
      if (noAnimation) {
        mesh.rotationQuaternion = new BABYLON.Quaternion.RotationAxis(axis, eA);
        animation_running = 0;
        if (stop) {
          animateListStage(list.shift(), noAnimation);
        }
      } else {
        var timeframe = (60 / fps) * 10;
        var d = 500;

        var frame = setInterval(
          (function (noAnimation) {
            return function () {
              $('.animation-button').css({
                pointerEvents: 'none',
              });
              animationTimer(noAnimation);
            };
          })(noAnimation),
          timeframe,
          t,
          b,
          c,
          d,
          stop
        );
      }

      function animationTimer(noAnimation) {
        if (t > d) {
          stopAnimation(noAnimation);
        } else {
          step = Math.easeInOutQuad(t, b, c, d);
          mesh.rotationQuaternion = new BABYLON.Quaternion.RotationAxis(axis, step);
          t += timeframe;
        }
      }

      function stopAnimation(noAnimation) {
        clearInterval(frame);
        animation_running = 0;
        deactivateButtons();
        if (typeof stop != 'undefined') {
          if (stop) {
            animateListStage(list.shift(), noAnimation);
          }
        }
      }
    };

    var animatePosition = function (meshData, noAnimation, stop) {
      animation_running = 1;
      posAnimation_running = 1;
      scene.meshes.forEach(function (mesh) {
        if (meshData['meshName'] == mesh.name) {
          // t=current time
          // b=start value
          // c=change in value
          // d=duration
          var c = new Array();
          var b = new Array();
          b.x = parseFloat(meshData['startPosition']['x']);
          b.y = parseFloat(meshData['startPosition']['y']);
          b.z = parseFloat(meshData['startPosition']['z']);
          c.x = parseFloat(meshData['endPos']['x']) - b.x;
          c.y = parseFloat(meshData['endPos']['y']) - b.y;
          c.z = parseFloat(meshData['endPos']['z']) - b.z;
          var fps = 50;
          var t = 0;
          if ((meshData.hasOwnProperty('noAnimation') && meshData['noAnimation']) || noAnimation) {
            mesh.position.x = parseFloat(meshData['endPos']['x']);
            mesh.position.y = parseFloat(meshData['endPos']['y']);
            mesh.position.z = parseFloat(meshData['endPos']['z']);
            animation_running = 0;
            posAnimation_running = 0;
            if (stop) {
              animatePositionStage(positionList.shift(), noAnimation);
            }
          } else {
            var timeframe = (60 / fps) * 10;
            var d = 500;
            var frame = setInterval(
              (function (noAnimation) {
                return function () {
                  $('.animation-button').css({
                    pointerEvents: 'none',
                  });
                  animationPositionTimer(noAnimation);
                };
              })(noAnimation),
              timeframe,
              t,
              meshData,
              d,
              stop
            );
          }

          function animationPositionTimer(noAnimation) {
            if (t > d) {
              stopPositionAnimation(noAnimation);
            } else {
              c = new Array();
              b = new Array();
              b.x = parseFloat(meshData['startPosition']['x']);
              b.y = parseFloat(meshData['startPosition']['y']);
              b.z = parseFloat(meshData['startPosition']['z']);
              c.x = parseFloat(meshData['endPos']['x']) - b.x;
              c.y = parseFloat(meshData['endPos']['y']) - b.y;
              c.z = parseFloat(meshData['endPos']['z']) - b.z;
              mesh.position.x = Math.easeInOutQuad(t, b.x, c.x, d);
              mesh.position.y = Math.easeInOutQuad(t, b.y, c.y, d);
              mesh.position.z = Math.easeInOutQuad(t, b.z, c.z, d);
              t += timeframe;
            }
          }

          function stopPositionAnimation(noAnimation) {
            clearInterval(frame);
            animation_running = 0;
            posAnimation_running = 0;
            deactivateButtons();
            if (typeof stop != 'undefined') {
              if (stop) {
                animatePositionStage(positionList.shift(), noAnimation);
              }
            }
          }
        }
      });
    };

    var animateListStage = function (listStage, noAnimation) {
      if (typeof listStage != 'undefined') {
        var k = 0;
        for (var index in listStage['rotation']) {
          k++;
          if (k == listStage['rotation'].length) animateMesh(listStage['rotation'][index], noAnimation, 1);
          else animateMesh(listStage['rotation'][index], noAnimation, 0);
        }
      }
    };

    var animatePositionStage = function (positionStage, noAnimation) {
      if (typeof positionStage !== 'undefined') {
        var k = 0;
        for (var index in positionStage['position']) {
          k++;
          if (k == positionStage['position'].length) animatePosition(positionStage['position'][index], noAnimation, 1);
          else animatePosition(positionStage['position'][index], noAnimation, 0);
        }
      }
    };

    var toAnimate = true;

    if (reverse) {
      list = list.reverse();
      positionList = positionList.reverse();
    }

    animateListStage(list.shift(), noAnimation);
    if (positionList.length && toAnimate) {
      animatePositionStage(positionList.shift(), noAnimation);
    }
  };

  BabylonModel.prototype.initMaterial = function () {
    _scene = this.scene;
    this.scene.meshes.forEach(function (mesh) {
      if (mesh.material) {
        if (mesh.material.name == 'white') {
          mesh.material.backFaceCulling = false;
          mesh.material.diffuseColor = new BABYLON.Color3(0.85, 0.85, 0.85);
        }
      }
    });
  };

  BabylonModel.prototype.changeCameraTarget = function () {
    var radius = arcCamera.radius;
    if (max_x >= old_max_x) {
      old_max_x = max_x;

      arcCamera.lowerRadiusLimit = old_max_x / 10;
      arcCamera.upperRadiusLimit = old_max_x + old_max_x * 2;
    } else if (max_x <= old_max_x) {
      old_max_x = max_x;

      arcCamera.lowerRadiusLimit = old_max_x / 10;
      arcCamera.upperRadiusLimit = old_max_x + old_max_x * 2;
    } else if (max_y >= old_max_y) {
      old_max_y = max_y;

      arcCamera.lowerRadiusLimit = old_max_y / 10;
      arcCamera.upperRadiusLimit = old_max_y + old_max_y * 2;
    } else if (max_y <= old_max_y) {
      old_max_y = max_y;

      arcCamera.lowerRadiusLimit = old_max_y / 10;
      arcCamera.upperRadiusLimit = old_max_y + old_max_y * 2;
    } else {
      arcCamera.radius = radius;
    }
    saveInitialCameraValues();
  };

  BabylonModel.prototype.changeInitialTexture = function () {
    var path = texturesUrl;
    if (outsideTexture) {
      var outsideMat = window.scene.getMaterialByName('BackMaterial');
      if (!isProof) {
        outsideMat.getBlockByName('baseMap').texture = new BABYLON.Texture(path + outsideTexture, _scene);
      } else {
        outsideMat.getBlockByName('baseMap').texture = new BABYLON.Texture(outsideTexture, _scene);
      }
    }
    if (insideTexture) {
      var insideMat = window.scene.getMaterialByName('FaceMaterial');
      insideMat.getBlockByName('baseMap').texture = new BABYLON.Texture(path + insideTexture, _scene);
    }
  };

  BabylonModel.prototype.changeInitialTextureWithCallback = function (callback) {
    // var outsideTexture, insideTexture
    var isLoad = 0;
    var interval = setInterval(checkIfIsLoad, 50);
    function checkIfIsLoad() {
      if (isLoad == 2) {
        clearInterval(interval);
        if (typeof callback === 'function') {
          callback();
        }
      }
    }

    var path = texturesUrl;
    if (Engine3DVariables.currentOutsideTexture == null) {
      Engine3DVariables.currentOutsideTexture = path + outsideTexture;
    }
    if (Engine3DVariables.currentInsideTexture == null) {
      Engine3DVariables.currentInsideTexture = path + insideTexture;
    }

    if (outsideTexture) {
      if (!isProof) {
        var x = new BABYLON.Texture(Engine3DVariables.currentOutsideTexture, window._scene, undefined, undefined, undefined, function () {
          window.scene.getMaterialByName('BackMaterial').getBlockByName('baseMap').texture = x;
          isLoad++;
        });
      } else {
        var y = (window._scene.materials[1].getBlockByName('baseMap').texture = new BABYLON.Texture(Engine3DVariables.currentOutsideTexture, window._scene, undefined, undefined, undefined, function () {
          window.scene.getMaterialByName('FaceMaterial').getBlockByName('baseMap').texture = y;
          isLoad++;
        }));
      }
    } else {
      isLoad++;
    }
    if (insideTexture) {
      var z = new BABYLON.Texture(Engine3DVariables.currentInsideTexture, window._scene, undefined, undefined, undefined, function () {
        window.scene.getMaterialByName('FaceMaterial').getBlockByName('baseMap').texture = z;
        isLoad++;
      });
    } else {
      isLoad++;
    }
  };

  // ======================================================  STANDARD  =================================================== //
  var createMeshesStandard = function () {
    var UVdimension = [];

    for (var name in points['points']) {
      if (typeof points['points'][name][0] === 'string') {
        meshesParents.push(points['points'][name][0]);
        points['points'][name].shift();
      } else {
        meshesParents.push('noParent');
      }
    }

    //CALCUL UV
    for (var name in points['points']) {
      for (var i = 0; i <= points['points'][name].length - 2; i += 2) {
        if (points['points'][name][i] <= min_x) {
          min_x = points['points'][name][i];
        }

        if (points['points'][name][i] >= max_x) {
          max_x = points['points'][name][i];
        }

        if (points['points'][name][i + 1] <= min_y) {
          min_y = points['points'][name][i + 1];
        }
        if (points['points'][name][i + 1] >= max_y) {
          max_y = points['points'][name][i + 1];
        }
      }
    }
    //  CALCUL MIN MAX X Y

    if (tmp == 1) {
      old_max_x = max_x;
      old_max_y = max_y;
      old_min_x = min_x;
      old_min_y = min_y;

      tmp--;
    }

    UVdimension['p1'] = [];
    UVdimension['p1']['x'] = max_x;
    UVdimension['p1']['y'] = max_y;

    UVdimension['p2'] = [];
    UVdimension['p2']['x'] = min_x;
    UVdimension['p2']['y'] = min_y;

    var w = Math.abs(max_x - min_x);
    var h = Math.abs(max_y - min_y);
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['width'] !== 'undefined') {
        w = points['svgDim']['width'];
      }
    }
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['height'] !== 'undefined') {
        h = points['svgDim']['height'];
      }
    }

    var x = -1;
    for (var name in points['points']) {
      x++;

      name_array.push(name);

      var indici = [];
      var puncte = [];
      var uv = [];
      var normals = [];

      for (var i = 0; i < points['points'][name].length; i += 2) {
        //PUNCTE
        puncte.push(points['points'][name][i]);
        puncte.push(thickness);
        puncte.push(points['points'][name][i + 1]);

        //INDICI
        if ((i + 1) % 2 != 0) {
          indici.push(parseInt(i / 2));
        }

        //UVs
        var u = 1 - (points['points'][name][i] - min_x + parseFloat(points.svgDim.margin)) / w; //lungime
        var v = (points['points'][name][i + 1] - min_y + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

        uv.push(u);
        uv.push(-v);
        normals.push(new BABYLON.Vector3(0, 0, -1));
      }
      // PUNCTE INDICI UV

      var earcut_points = points['points'][name];
      indici = earcut(earcut_points);

      var vertexData = new BABYLON.VertexData();
      BABYLON.VertexData.ComputeNormals(puncte, indici, normals);
      vertexData.positions = puncte;
      vertexData.indices = indici;
      vertexData.uvs = uv;
      vertexData.normals = normals;

      var meshName = new BABYLON.Mesh(name, window.scene);

      vertexData.applyToMesh(meshName);
      meshName.material = FaceMaterial;
    }
  };

  var createMeshesCopyStandard = function () {
    var UVdimension = [];

    UVdimension['p1'] = [];
    UVdimension['p1']['x'] = max_x;
    UVdimension['p1']['y'] = max_y;

    UVdimension['p2'] = [];
    UVdimension['p2']['x'] = min_x;
    UVdimension['p2']['y'] = min_y;

    var w = Math.abs(max_x - min_x);
    var h = Math.abs(max_y - min_y);
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['width'] !== 'undefined') {
        w = points['svgDim']['width'];
      }
    }
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['height'] !== 'undefined') {
        h = points['svgDim']['height'];
      }
    }

    var index = -1;
    for (var name in points['points']) {
      index++;
      var indici = [];
      var puncte = [];
      var uv = [];
      var normals = [];

      for (var i = 0; i < points['points'][name].length; i += 2) {
        //PUNCTE
        puncte.push(points['points'][name][i]);
        puncte.push(0);
        puncte.push(points['points'][name][i + 1]);

        //INDICI
        if ((i + 1) % 2 != 0) {
          indici.push(parseInt(i / 2));
        }

        //UVs
        var u = (points['points'][name][i] - min_x + parseFloat(points.svgDim.margin)) / w; //lungime
        var v = (points['points'][name][i + 1] - min_y + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

        uv.push(u);
        uv.push(-v);
        normals.push(new BABYLON.Vector3(0, 0, -1));
      }
      // PUNCTE INDICI UV

      var earcut_points = points['points'][name];
      indici = earcut(earcut_points);

      var vertexData = new BABYLON.VertexData();
      BABYLON.VertexData.ComputeNormals(puncte, indici, normals);
      vertexData.positions = puncte;
      vertexData.indices = indici;
      vertexData.uvs = uv;
      vertexData.normals = normals;

      var meshName = new BABYLON.Mesh(name + '_copy', window.scene);

      vertexData.applyToMesh(meshName);
      meshName.material = BackMaterial;
      meshName.flipFaces(true);

      var merge = BABYLON.Mesh.MergeMeshes([window.scene.meshes[0], meshName], true);
      window.scene.meshes.push(window.scene.meshes.shift());

      var multimat = new BABYLON.MultiMaterial('multi', window.scene);
      multimat.subMaterials.push(FaceMaterial);
      multimat.subMaterials.push(BackMaterial);

      merge.material = multimat;

      merge.subMeshes = [];

      var vertices = merge.getTotalVertices();
      var indices = merge.getTotalIndices();

      merge.subMeshes.push(new BABYLON.SubMesh(0, 0, vertices / 2, 0, indices / 2, merge));
      merge.subMeshes.pop();
      merge.subMeshes.push(new BABYLON.SubMesh(1, vertices / 2, vertices / 2, indices / 2, indices / 2, merge));
      merge.subMeshes.pop();
    }
  };

  var createSidesStandard = function () {
    var index = -1;
    for (var name in points['points']) {
      var toMerge = [];

      index++;
      var reset = points['points'][name].length;

      for (var i = 0; i < points['points'][name].length; i += 2) {
        var puncte = [];

        puncte.push(new BABYLON.Vector3(points['points'][name][i % reset], 0, points['points'][name][(i + 1) % reset]));
        puncte.push(new BABYLON.Vector3(points['points'][name][(i + 2) % reset], 0, points['points'][name][(i + 3) % reset]));
        puncte.push(new BABYLON.Vector3(points['points'][name][i % reset], thickness, points['points'][name][(i + 1) % reset]));
        puncte.push(new BABYLON.Vector3(points['points'][name][(i + 2) % reset], thickness, points['points'][name][(i + 3) % reset]));

        var ribbonMesh = BABYLON.Mesh.CreateRibbon(name + '_sidePlanes', [puncte], false, false, 0, window.scene);

        ribbonMesh.material = CartonMaterial;

        toMerge.push(ribbonMesh);
      }

      if (toMerge.length > 0) {
        var merge = BABYLON.Mesh.MergeMeshes(toMerge, true);

        merge.parent = window.scene.meshes[index];
        merge.isPickable = false;
      }
    }
  };

  var createParentsStandard = function () {
    var copy_;
    // PARENTS FOR EACH MESH
    for (var pars = 0; pars < name_array.length; pars++) {
      if (meshesParents[pars] != 'noParent') {
        for (var index in window.scene.meshes) {
          if (meshesParents[pars] == window.scene.meshes[index].name.replace('_merged', '')) {
            copy_ = window.scene.meshes[index];
            break;
          }
        }
        window.scene.meshes[pars].parent = copy_;
      }
    }
  };

  var createPivotAxisStandard = function () {
    for (var name in points['points']) {
      if (typeof points['points'][name][0] === 'string') {
        points['points'][name].shift();
      }
    }

    for (var index = 0; index < name_array.length; index++) {
      var name = window.scene.meshes[index].name.replace('_merged', '');

      var pivotx = points['axis'][name].pivot.x;
      var pivoty = points['axis'][name].pivot.y;

      var vx_ = points['axis'][name].target.x;
      var vz_ = points['axis'][name].target.y;

      var vx = vx_ - pivotx;
      var vz = vz_ - pivoty;

      var mv = Math.sqrt(Math.pow(vx, 2) + Math.pow(vz, 2)); //magnitude
      var quaternion = [vx / mv, thickness, vz / mv];

      Engine3DVariables.meshes[name].axis.quaternion = [];
      Engine3DVariables.meshes[name].axis.quaternion[0] = quaternion[0];
      Engine3DVariables.meshes[name].axis.quaternion[1] = 0;
      Engine3DVariables.meshes[name].axis.quaternion[2] = quaternion[2];

      if (Engine3DVariables.meshes[name].fold == 'Out') {
        window.scene.meshes[index].setPivotMatrix(BABYLON.Matrix.Translation(-pivotx, -thickness, -pivoty), true);
      } else {
        window.scene.meshes[index].setPivotMatrix(BABYLON.Matrix.Translation(-pivotx, 0, -pivoty), true);
      }

      window.scene.meshes[index].name = name;
    }
  };

  var updateMeshesStandard = function (result) {
    points = result.points_only;
    prevPoints = points;

    while (_scene.meshes.length != 0) {
      _scene.meshes[0].dispose();
    }

    meshesParents = [];
    curves_count = 0;
    axisPoints = [];
    puncte_finale_sus = [];
    puncte_finale_jos = [];
    puncte_finale_sides = [];
    name_array = [];
    curve_parent = [];
    uvsCurve = [];
    toBuild_no_y = [];

    name_array = [];
    axisPoints = [];
    uvsCurve = [];

    min_x = Infinity;
    min_y = Infinity;
    max_x = -Infinity;
    max_y = -Infinity;

    createMeshesStandard();

    createMeshesCopyStandard();

    if (fluteType !== 'default' && Engine3DVariables.enableCorrugation === 1) {
      corrugatedBoard();
    } else {
      createSidesStandard();
    }

    createParentsStandard();

    createPivotAxisStandard();
  };

  var animateCamera = function (startCam, endCam, target) {
    var frames = 50;
    var alphaAnim = new BABYLON.Animation('alphaAnim', 'alpha', 30, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
    var betaAnim = new BABYLON.Animation('betaAnim', 'beta', 30, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
    var radiusAnim = new BABYLON.Animation('radiusAnim', 'radius', 30, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

    var easingFunction = new BABYLON.QuadraticEase();
    easingFunction.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

    alphaAnim.setEasingFunction(easingFunction);
    betaAnim.setEasingFunction(easingFunction);
    radiusAnim.setEasingFunction(easingFunction);
    var keyA = [
      {
        frame: 0,
        value: startCam.alpha,
      },
      {
        frame: frames,
        value: endCam.alpha,
      },
    ];
    var keyB = [
      {
        frame: 0,
        value: startCam.beta,
      },
      {
        frame: frames,
        value: endCam.beta,
      },
    ];
    var keyR = [
      {
        frame: 0,
        value: startCam.radius,
      },
      {
        frame: frames,
        value: endCam.radius,
      },
    ];

    BABYLON.AbstractMesh.prototype.moveTo = function (targetPos, speed) {
      var ease = new BABYLON.CubicEase();
      ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
      BABYLON.Animation.CreateAndStartAnimation('at5', this, 'position', speed, frames, this.position, targetPos, 0, ease, function () {
        arcCamera.setTarget(arcCamera.lockedTarget.position);
        delete arcCamera.lockedTarget;
        setTimeout(() => {
          cameraAnimation_running = false;
        }, 500);
      });
    };

    alphaAnim.setKeys(keyA);
    betaAnim.setKeys(keyB);
    radiusAnim.setKeys(keyR);
    arcCamera.animations.push(alphaAnim);
    arcCamera.animations.push(betaAnim);
    arcCamera.animations.push(radiusAnim);
    scene.beginAnimation(arcCamera, 0, frames, false, 1);

    arcCamera.lockedTarget = BABYLON.Mesh.CreateBox('target', 25, scene);
    arcCamera.lockedTarget.isPickable = false;
    arcCamera.lockedTarget.visibility = 0;
    arcCamera.lockedTarget.position = arcCamera.target;
    arcCamera.lockedTarget.moveTo(target, 30);
  };

  var initHighlight = function () {
    const hoverMat = scene.getMaterialByName('BackMaterial').clone('highlight'); //any material
    hoverMat.getBlockByName('enable_highlight').value = 1;
    hoverMat.getBlockByName('highlight_color').value = new BABYLON.Color3(0.33, 0.59, 0.7);
    let lastMesh = null;
    let hoveredMeshes = [];
    scene.onBeforeRenderObservable.add(() => {
      if (enableHighlight === true) {
        const pickResult = scene.pick(scene.pointerX, scene.pointerY, (mesh) => mesh.isPickable && mesh.isVisible && mesh.isReady(), false, arcCamera);
        if (pickResult.hit) {
          if (lastMesh !== pickResult.pickedMesh.id) {
            if (
              hoveredMeshes.filter((obj) => {
                return pickResult.pickedMesh.id === obj.meshId;
              }).length == 0
            ) {
              unsetHoverColor(hoveredMeshes, scene);
              hoveredMeshes = [];
              lastMesh = null;

              hoveredMeshes.push({
                meshId: pickResult.pickedMesh.id,
                matId: pickResult.subMeshId,
              });

              setHoverColor(hoveredMeshes, scene);
              lastMesh = pickResult.pickedMesh.id;
            }
          }
        } else if (hoveredMeshes.length > 0) {
          unsetHoverColor(hoveredMeshes, scene);
          hoveredMeshes = [];
          lastMesh = null;
        }
      }
    });

    function setHoverColor(hoveredMeshes, scene) {
      hoveredMeshes.forEach((data) => {
        const meshId = data.meshId;
        const matId = data.matId;
        const mesh = scene.getMeshByID(meshId);
        data.originalMatName = mesh.material.subMaterials[matId].name;
        if (data.originalMatName !== 'highlight') {
          mesh.material.subMaterials[matId] = hoverMat;
        }
      });
      return hoveredMeshes;
    }

    function unsetHoverColor(hoveredMeshes, scene) {
      hoveredMeshes.forEach((data) => {
        const meshId = data.meshId;
        const matId = data.matId;
        const mesh = scene.getMeshByID(meshId);
        const hoverMatName = mesh.material.subMaterials[matId].name;
        if (hoverMatName === 'highlight') {
          mesh.material.subMaterials[matId] = scene.getMaterialByName(data.originalMatName);
        }
      });
    }

    scene.onPointerDown = function (evt, pickResult) {
      // We try to pick an object
      if (pickResult.hit) {
        var meshName = pickResult.pickedMesh.name;
        if (enableMeshFocus == true) {
          var outside = true;
          var side = pickResult.pickedMesh.subMeshes[pickResult.subMeshId].materialIndex;
          if (side === 0) {
            //somewhat hardcoded. 1 is outside, 0 is inside
            outside = false;
          }
          window.highlightMesh(meshName, outside);
        }
      }
    };
  };
  window.highlightMesh = function (meshName = null, outside = true) {
    if (!cameraAnimation_running) {
      cameraAnimation_running = true;
      if (meshName !== null) {
        var mesh = scene.getMeshByName(meshName);
      }
      if (typeof mesh === 'undefined' || mesh === null) {
        console.log('mesh not found');
        cameraAnimation_running = false;
        return;
      }

      parent.postMessage(
        JSON.stringify({
          clickedMesh: meshName,
          outside: outside,
        }),
        '*'
      );

      lastHighlightedMesh = mesh;
      mesh.updateFacetData();

      var multiplier = 1;
      if (outside) {
        multiplier = -1;
      }

      var distance = arcCamera.radius;
      var bb = mesh.getBoundingInfo();
      var meshCenter = bb.boundingBox.centerWorld;

      var normalized_direction = mesh.getFacetNormal(0);

      var distanceVector = normalized_direction.multiplyByFloats(distance, distance, distance);
      distanceVector = distanceVector.multiplyByFloats(multiplier, multiplier, multiplier);

      var camPos = meshCenter.add(distanceVector);

      var tempCamera = new BABYLON.ArcRotateCamera('tempCamera', arcCamera.alpha, arcCamera.beta, arcCamera.radius, arcCamera.target, scene);
      tempCamera.setTarget(meshCenter);
      tempCamera.setPosition(camPos);
      var endCam = {
        alpha: tempCamera.alpha,
        beta: tempCamera.beta,
        radius: tempCamera.radius,
      };
      var startCam = {
        alpha: arcCamera.alpha,
        beta: arcCamera.beta,
        radius: arcCamera.radius,
      };
      tempCamera.dispose();
      animateCamera(startCam, endCam, meshCenter);
    }
  };

  window.clearHighlight = function () {
    if (lastHighlightedMesh) {
      lastHighlightedMesh = null;
    }
  };

  var calculateBB = function (points) {
    var BB = {
      minX: Infinity,
      minY: Infinity,
      maxX: -Infinity,
      maxY: -Infinity,
    };
    for (var i = 0; i < points.length; i++) {
      if (typeof points[0] === 'string') {
        continue;
      }
      if (points[i] > BB.maxX) {
        BB.maxX = points[i];
      }
      if (points[i] < BB.minX) {
        BB.minX = points[i];
      }
      if (points[i + 1] > BB.maxY) {
        BB.maxY = points[i + 1];
      }
      if (points[i + 1] < BB.minY) {
        BB.minY = points[i + 1];
      }
      i++;
    }
    return BB;
  };
  var createEdge = function (BB, flute) {
    var thickness = parseFloat(Engine3DVariables.thickness);
    var Xlen = BB.maxX - BB.minX;
    var Ylen = BB.maxY - BB.minY;
    var PhaseShift = BB.minX;
    var repositionX = BB.minX;
    var repositionY = BB.minY;
    var direction = [new BABYLON.Vector3(0, 0, 0), new BABYLON.Vector3(0, 0, Ylen)];
    if (Engine3DVariables.fluteDirection && Engine3DVariables.fluteDirection !== '') {
      //fluteDirection can be either L or S
      if (Engine3DVariables.fluteDirection === 'S') {
        let tmp = Xlen;
        Xlen = Ylen;
        Ylen = tmp;
        repositionY = BB.maxY;
        PhaseShift = -BB.maxY;
        direction = [new BABYLON.Vector3(0, 0, 0), new BABYLON.Vector3(Ylen, 0, 0)];
      }
    }
    var path = [];
    var period, yPeriod, amplitude, correctedAmplitude, fluteThickness, point, vShift;
    var sinePass = function (startPoint, period, rest = null) {
      let steps = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90]; //represents the % value of where the points inside a period are located
      if (rest !== null) {
        steps = steps.filter((item) => {
          return item <= rest;
        });
      }
      let x, y;
      var path = [];
      steps.forEach(function (step) {
        x = startPoint + (period * step) / 100;
        //y=Amplitude*sin((2*PI/Period)(x+PhaseShift)) + VerticalShift
        y = correctedAmplitude * Math.sin((x + period / 4 + PhaseShift) * yPeriod) + thickness / 2 - fluteThickness / 2 + vShift;
        point = new BABYLON.Vector3(x, y, 0);
        path.push(point);
      });
      if (rest !== null) {
        x = startPoint + (period * rest) / 100;
      } else {
        x = startPoint + (period * 100) / 100;
      }
      y = correctedAmplitude * Math.sin((x + period / 4 + PhaseShift) * yPeriod) + thickness / 2 - fluteThickness / 2 + vShift;
      point = new BABYLON.Vector3(x, y, 0);
      path.push(point);
      return path;
    };
    var calculateEdgePoints = function () {
      path = [];
      var numberOfPeriods = Math.floor(Xlen / period);
      for (let i = 0; i < numberOfPeriods; i++) {
        path = path.concat(sinePass(i * period, period));
      }
      var rest = Xlen % period;
      let restPercent = (rest / period) * 100;
      path = path.concat(sinePass(numberOfPeriods * period, period, restPercent));
      //go back route
      for (let i = path.length - 1; i >= 0; i--) {
        let y = path[i].y + fluteThickness / 2;
        path.push(new BABYLON.Vector3(path[i].x, y, path[i].z));
      }
      var edge = BABYLON.MeshBuilder.ExtrudeShape('edge', { shape: path, path: direction }, scene);
      edge.material = scene.getMaterialByName('CartonMaterial');
      edge.position.x = repositionX;
      edge.position.z = repositionY;
      return edge;
    };
    switch (flute) {
      case 'single':
        period = thickness * 2; // if number is higher, quality increases, but load time decreases drastically
        yPeriod = (Math.PI * 2) / period; //https://3d-epicycles.ashayp.com/
        amplitude = thickness / 2; // thickness/2 because the height of the edge should be 2*amplitude of sine wave.
        correctedAmplitude = amplitude - Math.max(0.08, amplitude * 0.1); //to prevent edge from z-fighting with the top and bottom meshes. 10% but minimum 0.08
        fluteThickness = correctedAmplitude * 0.1; //how thick the corrugation is
        vShift = 0; //in the middle
        return calculateEdgePoints();
        break;
      case 'double':
        period = thickness * 0.8; // should be 4 times higher than amplitude
        yPeriod = (Math.PI * 2) / period; //https://3d-epicycles.ashayp.com/
        amplitude = thickness * 0.2; // 20% of the thickness because the height of the edge should be 2*amplitude of sine wave and we want our height to be 40%.
        correctedAmplitude = amplitude - Math.max(0.08, amplitude * 0.1); //to prevent edge from z-fighting with the top and bottom meshes. 10% but minimum 0.08
        fluteThickness = correctedAmplitude * 0.1; //how thick the corrugation is
        vShift = thickness * 0.3; //shift up by 30% of thickness
        let topWave = calculateEdgePoints();
        path = [];
        path.push(new BABYLON.Vector3(0, thickness * 0.59 - fluteThickness, 0));
        path.push(new BABYLON.Vector3(Xlen, thickness * 0.59 - fluteThickness, 0));
        path.push(new BABYLON.Vector3(Xlen, thickness * 0.59 + fluteThickness, 0));
        path.push(new BABYLON.Vector3(0, thickness * 0.59 + fluteThickness, 0));
        path.push(new BABYLON.Vector3(0, thickness * 0.59 - fluteThickness, 0));
        var line = BABYLON.MeshBuilder.ExtrudeShape('edge', { shape: path, path: direction }, scene);
        line.position.x = repositionX;
        line.position.z = repositionY;
        period = thickness * 1.2; // should be 4 times higher than amplitude
        amplitude = thickness * 0.3; // 20% of the thickness because the height of the edge should be 2*amplitude of sine wave and we want our height to be 40%.
        correctedAmplitude = amplitude - Math.max(0.08, amplitude * 0.1); //to prevent edge from z-fighting with the top and bottom meshes. 10% but minimum 0.08
        vShift = -thickness * 0.2; //shift up by 30% of thickness
        let botWave = calculateEdgePoints();
        var edge = BABYLON.Mesh.MergeMeshes([topWave, line, botWave], true);
        edge.material = scene.getMaterialByName('CartonMaterial');
        return edge;
    }
  };
  var cutEdge = function (points, name, edgeMesh) {
    var path = [];
    var thickness = parseFloat(Engine3DVariables.thickness);
    for (var i = 0; i < points.length; i++) {
      if (typeof points[0] === 'string') {
        continue;
      }
      var p = new BABYLON.Vector3(-points[i + 1], -points[i], 0);
      path.push(p);
      i++;
    }
    path.push(path[0]);
    var direction = [new BABYLON.Vector3(0, 0, 0), new BABYLON.Vector3(0, thickness, 0)];
    var box = BABYLON.MeshBuilder.ExtrudeShape('box', { shape: path, path: direction }, scene);
    var aCSG = BABYLON.CSG.FromMesh(edgeMesh);
    var bCSG = BABYLON.CSG.FromMesh(box);
    var csg = bCSG.intersect(aCSG);
    var newMesh = csg.toMesh(name + '_edge', scene.getMaterialByName('CartonMaterial'), scene);
    scene.removeMesh(box);
    scene.removeMesh(edgeMesh);
    return newMesh;
  };
  var corrugatedBoard = function () {
    var index = -1;
    var localPoints = [];
    if (STANDARD_MODEL == true) {
      localPoints = points['points'];
    } else {
      localPoints = small_area_points;
    }
    for (var name in localPoints) {
      index++;
      if (typeof localPoints[name][0] === 'string') {
        continue;
      }
      var meshPoints = localPoints[name];
      var BB = calculateBB(meshPoints);
      var edgeMesh = createEdge(BB, fluteType);
      var edge = cutEdge(localPoints[name], name, edgeMesh);
      edge.isPickable = false;
      edge.parent = window.scene.meshes[index];
    }
  };
  var setFluteType = function (fluteInput) {
    if (Engine3DVariables.WH && Engine3DVariables.WH !== '') {
      fluteInput = Engine3DVariables.WH;
    }
    if (!fluteInput) {
      fluteType = 'default';
    }
    switch (fluteInput) {
      case 'G':
      case 'F':
        fluteType = 'default';
        break;
      case 'A':
      case 'B':
      case 'C':
      case 'D':
      case 'E':
        fluteType = 'single';
        break;
      case 'EB':
      case 'AB':
      case 'BC':
        fluteType = 'double';
        break;
      default:
        if (parseFloat(Engine3DVariables.thickness) < 1.5) {
          fluteType = 'default';
          break;
        } else {
          if (parseFloat(Engine3DVariables.thickness) < 6.4) {
            fluteType = 'single';
            break;
          } else {
            fluteType = 'double';
            break;
          }
        }
    }
  };

  var createMyMaterials = async function (callback) {
    let logarithmicDepth = true;
    let maxSimultaneousLights = 9;
    CartonMaterial = new BABYLON.NodeMaterial('CartonMaterial', window.scene);
    await CartonMaterial.loadAsync('../packing_textures/nodeMaterial_03.json');
    CartonMaterial.getBlockByName('baseMap').texture = new BABYLON.Texture('../packing_textures/karton.jpg', window.scene, undefined, undefined, BABYLON.Texture.NEAREST_NEAREST);
    CartonMaterial.backFaceCulling = false;
    CartonMaterial.needDepthPrePass = true;
    CartonMaterial.useLogarithmicDepth = logarithmicDepth;
    CartonMaterial.maxSimultaneousLights = maxSimultaneousLights;
    CartonMaterial.build();

    FaceMaterial = CartonMaterial.clone('FaceMaterial');
    FaceMaterial.getBlockByName('baseMap').texture = new BABYLON.Texture('../packing_textures/karton.jpg', window.scene, undefined, undefined, BABYLON.Texture.NEAREST_NEAREST);
    // FaceMaterial.build();

    BackMaterial = CartonMaterial.clone('BackMaterial');
    BackMaterial.getBlockByName('baseMap').texture = new BABYLON.Texture('../packing_textures/white.png', window.scene, undefined, undefined, BABYLON.Texture.NEAREST_NEAREST);
    // BackMaterial.build();

    callback();
  };

  var getCurrentAnimationStage = function () {
    return model.animation.stage.toString();
  };

  var getCameraTarget = function () {
    let x = arcCamera.target.x;
    let y = arcCamera.target.y;
    let z = arcCamera.target.z;

    return { x: x, y: y, z: z };
  };

  var getCameraPosition = function () {
    var xpos = arcCamera.position.x;
    var ypos = arcCamera.position.y;
    var zpos = arcCamera.position.z;

    console.log(xpos);
    console.log(ypos);
    console.log(zpos);

    return { x: xpos, y: ypos, z: zpos };
  };

  var setQuality = function () {
    if (STANDARD_MODEL == false) {
      STANDARD_MODEL = true;
    } else if (STANDARD_MODEL == true) {
      STANDARD_MODEL = false;
    } else if (typeof STANDARD_MODEL === 'undefined') {
      STANDARD_MODEL = true;
    }
  };

  var updateCamera = function () {
    if (max_x > max_y) {
      arcCamera.upperRadiusLimit = max_x + max_x * 2;
    } else if (max_x <= max_y) {
      arcCamera.upperRadiusLimit = max_y + max_y * 2;
    }

    if (min_x > min_y) {
      arcCamera.lowerRadiusLimit = min_x;
    } else if (min_x <= min_y) {
      arcCamera.lowerRadiusLimit = min_y;
    }

    if (Engine3DVariables.cameraSettings.cameraCenter.length > 0) {
      for (var name in Engine3DVariables.meshes) {
        if (name == Engine3DVariables.cameraSettings.cameraCenter) {
          buffer = name;
          break;
        }
      }

      for (var i = 0; i < name_array.length; i++) {
        if (buffer == name_array[i]) {
          buffer = i;
          break;
        }
      }

      var local_x = _scene.meshes[buffer].getBoundingInfo().boundingBox.minimumWorld.x;
      var local_y = _scene.meshes[buffer].getBoundingInfo().boundingBox.minimumWorld.y;
      var local_z = _scene.meshes[buffer].getBoundingInfo().boundingBox.minimumWorld.z;

      var global_x = _scene.meshes[buffer].getBoundingInfo().boundingBox.maximumWorld.x;
      var global_y = _scene.meshes[buffer].getBoundingInfo().boundingBox.maximumWorld.y;
      var global_z = _scene.meshes[buffer].getBoundingInfo().boundingBox.maximumWorld.z;

      arcCamera.target.x = (local_x + global_x) / 2;
      arcCamera.target.y = (local_y + global_y) / 2;
      arcCamera.target.z = (local_z + global_z) / 2;
    }

    scene.activeCamera = arcCamera;

    arcCamera.panningSensibility = 10;
    arcCamera.wheelPrecision = 1;
    saveInitialCameraValues();
  };

  window.getCameraTarget = getCameraTarget;
  window.getCameraPosition = getCameraPosition;
  window.getCurrentAnimationStage = getCurrentAnimationStage;
  window.setQuality = setQuality;

  // ======================================================  ADVANCED  =================================================== //

  function localRound(number, precision = 10) {
    return +(Math.round(number + 'e+' + precision) + 'e-' + precision);
  }

  var getFoldIndex = function (point1, point2) {
    for (var index in axisPoints) {
      var axis = axisPoints[index];
      if (point1.x == axis[0] && point1.y == axis[1]) {
        if (point2.x == axis[2] && point2.y == axis[3]) {
          return index;
        }
      } else if (point1.x == axis[2] && point1.y == axis[3]) {
        if (point2.x == axis[0] && point2.y == axis[1]) {
          return index;
        }
      }
    }
    return false;
  };

  var isFold = function (point1, point2) {
    for (var index in axisPoints) {
      var axis = axisPoints[index];
      if (point1.x == axis[0] && point1.y == axis[1]) {
        if (point2.x == axis[2] && point2.y == axis[3]) {
          return true;
        }
      } else if (point1.x == axis[2] && point1.y == axis[3]) {
        if (point2.x == axis[0] && point2.y == axis[1]) {
          return true;
        }
      }
    }
    return false;
  };

  var getFoldDirection = function (point1, point2) {
    for (var index in axisPoints) {
      var axis = axisPoints[index];
      if (point1.x == axis[0] && point1.y == axis[1]) {
        if (point2.x == axis[2] && point2.y == axis[3]) {
          return axis[4];
        }
      } else if (point1.x == axis[2] && point1.y == axis[3]) {
        if (point2.x == axis[0] && point2.y == axis[1]) {
          return axis[4];
        }
      }
    }
    return false;
  };

  var getAngle = function (point1, point2, point3) {
    var p1x = point1.x;
    var p1y = point1.y;
    var p2x = point2.x;
    var p2y = point2.y;
    var p3x = point3.x;
    var p3y = point3.y;

    var v1x = p1x - p2x;
    var v1y = p1y - p2y;

    var v2x = p3x - p2x;
    var v2y = p3y - p2y;

    var angle = Math.atan2(v2y, v2x) - Math.atan2(v1y, v1x);
    return angle;
  };

  var getSlope = function (point1, point2) {
    return Math.atan2(point2.y - point1.y, point2.x - point1.x);
  };

  var createSideCoords = function (initial, final, name) {
    var sideCoord = {
      initial: final,
      final: initial,
    };
    sideMeshes[name].push(sideCoord);
  };

  var getCoordOnCorner = function (point1, origin, point3, distance, angle, isOutside = false) {
    if (distance > 2) {
      //TODO : check with George if it's ok
      distance = 2;
    }
    var coord = {};
    var slope = (getSlope(origin, point1) + getSlope(origin, point3)) / 2;
    coord.x = distance * Math.cos(slope) + origin.x;
    coord.y = distance * Math.sin(slope) + origin.y;
    if (angle < 0) {
      isOutside = !isOutside;
    }
    if (isOutside) {
      coord.x = 2 * origin.x - coord.x;
      coord.y = 2 * origin.y - coord.y;
    }
    return coord;
  };

  var getCoordOnLine = function (point1, point2, distance, isOutside = false) {
    if (distance > 2) {
      //TODO : check with George if it's ok
      distance = 2;
    }
    var coord = {};
    var d = Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
    var t = distance / d;
    if (t < 0 || t > 1) {
      // t=0.5;
      // console.log(t);
    }
    coord.x = localRound((1 - t) * point1.x + t * point2.x);
    coord.y = localRound((1 - t) * point1.y + t * point2.y);
    if (isOutside) {
      coord.x = 2 * point2.x - coord.x;
      coord.y = 2 * point2.y - coord.y;
    }
    return coord;
  };

  var createCurveSide = function (curve, parent, name) {
    var aux = {
      x: curve[0].x,
      y: curve[curve.length - 1].y,
      z: curve[0].z,
    };

    curve.push(aux);
    var curvePoints = [];
    var curve_no_y = [];

    for (var i = 0; i < curve.length; i++) {
      curvePoints.push(curve[i].x);
      curvePoints.push(curve[i].y);
      curvePoints.push(curve[i].z);

      curve_no_y.push(curve[i].x);
      curve_no_y.push(curve[i].y);
      curve_no_y.push(curve[i].z);
    }

    var w = Math.abs(max_x - min_x);
    var h = Math.abs(max_y - min_y);
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['width'] !== 'undefined') {
        w = points['svgDim']['width'];
      }
    }
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['height'] !== 'undefined') {
        h = points['svgDim']['height'];
      }
    }

    var uv = [];
    var normals = [];
    for (var i = 0; i < curvePoints.length - 1; i += 3) {
      //UVs
      var u = (curvePoints[i] - min_x + parseFloat(points.svgDim.margin)) / w; //lungime
      var v = (curvePoints[i + 2] - min_y + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

      uv.push(u);
      uv.push(-v);
      normals.push(new BABYLON.Vector3(0, 0, -1));
    } // PUNCTE INDICI UV

    var earcut_points = curve_no_y;
    var indici = earcut(earcut_points, null, 3);
    indici = [8, 9, 0, 0, 1, 2, 2, 3, 4, 4, 5, 6, 6, 7, 8, 8, 0, 2, 2, 4, 6, 6, 8, 2]; // TODO: hardcoded
    var vertexData = new BABYLON.VertexData();
    BABYLON.VertexData.ComputeNormals(curvePoints, indici, normals);
    vertexData.positions = curvePoints;
    vertexData.indices = indici;
    vertexData.uvs = uv;
    vertexData.normals = normals;

    var meshName = new BABYLON.Mesh(scene.meshes[parent].name + '_side_curve', scene);

    vertexData.applyToMesh(meshName);
    meshName.material = CartonMaterial;
    meshName.parent = scene.meshes[parent];
    curveSides[name].push(scene.meshes.length - 1);
  };

  var optimizeModel = function () {
    var offset = 0;
    var parent = 0;
    for (var name in curveSides) {
      var toMerge = [];

      for (var index = 0; index < curveSides[name].length; index++) {
        toMerge.push(scene.meshes[curveSides[name][index] - offset]);
      }
      if (toMerge.length > 0) {
        var newMesh = BABYLON.Mesh.MergeMeshes(toMerge, false);
        for (var indexToSplice in curveSides[name]) {
          scene.meshes.splice(curveSides[name][indexToSplice] - offset, 1);
          offset++;
        }
        newMesh.name = name + '_curve_sides_merged';
        newMesh.parent = scene.meshes[parent++];
      } else parent++;
    }

    var string1 = 'side_plane_merged';
    var string2 = 'curve_sides_merged';
    var index1;
    var index2;
    var first = 0;
    for (var i = 0; i < scene.meshes.length; i++) {
      if (scene.meshes[i].name.search(string1) > 0 && first == 0) {
        index1 = i;
        first = 1;
      }
      if (scene.meshes[i].name.search(string2) > 0 && first == 1) {
        index2 = i;
        break;
      }
    }
  };

  var createAxisPointsAdvanced = function () {
    var k = 0;

    for (var i = 0; i < points['foldPoints'].length - 1; i += 2) {
      axisPoints[k] = [];

      var a = localRound(parseFloat(points['foldPoints'][i][0]));
      var b = localRound(parseFloat(points['foldPoints'][i][1]));

      var c = localRound(parseFloat(points['foldPoints'][i + 1][0]));
      var d = localRound(parseFloat(points['foldPoints'][i + 1][1]));

      axisPoints[k].push(a, b);
      axisPoints[k++].push(c, d);
    }

    for (var i in axisPoints) {
      axisPoints[i][4] = 'Out';
    }

    for (var name in points['points']) {
      var point1 = {
        x: Engine3DVariables.meshes[name].axis.pivot.x,
        y: Engine3DVariables.meshes[name].axis.pivot.y,
      };

      var point2 = {
        x: Engine3DVariables.meshes[name].axis.target.x,
        y: Engine3DVariables.meshes[name].axis.target.y,
      };

      var index = getFoldIndex(point1, point2);

      if (index !== false) {
        axisPoints[index][4] = Engine3DVariables.meshes[name].fold;
      }
    }
  };

  var createMeshesAdvanced = function () {
    var UVdimension = [];

    for (var name in points['points']) {
      if (typeof points['points'][name][0] === 'string') {
        meshesParents.push(points['points'][name][0]);
        points['points'][name].shift();
      } else {
        meshesParents.push('noParent');
      }
    }

    //CALCUL UV
    for (var name in points['points']) {
      for (var i = 0; i <= points['points'][name].length - 2; i += 2) {
        if (points['points'][name][i] <= min_x) {
          min_x = points['points'][name][i];
        }

        if (points['points'][name][i] >= max_x) {
          max_x = points['points'][name][i];
        }
        if (points['points'][name][i + 1] <= min_y) {
          min_y = points['points'][name][i + 1];
        }

        if (points['points'][name][i + 1] >= max_y) {
          max_y = points['points'][name][i + 1];
        }
      }
    }
    //  CALCUL MIN MAX X Y

    if (tmp == 1) {
      old_max_x = max_x;
      old_max_y = max_y;
      old_min_x = min_x;
      old_min_y = min_y;

      tmp--;
    }

    UVdimension['p1'] = [];
    UVdimension['p1']['x'] = max_x;
    UVdimension['p1']['y'] = max_y;

    UVdimension['p2'] = [];
    UVdimension['p2']['x'] = min_x;
    UVdimension['p2']['y'] = min_y;

    var w = Math.abs(max_x - min_x);
    var h = Math.abs(max_y - min_y);

    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['width'] !== 'undefined') {
        w = points['svgDim']['width'];
      }
    }
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['height'] !== 'undefined') {
        h = points['svgDim']['height'];
      }
    }

    var newPoints = [];

    for (var name in points['points']) {
      name_array.push(name);

      newPoints[name] = [];
      curvePoints[name] = [];
      var currentMesh = points['points'][name];
      var reset = currentMesh.length;
      for (var index = 0; index < currentMesh.length; index += 2) {
        var point1 = {};
        point1.x = currentMesh[index % reset];
        point1.y = currentMesh[(index + 1) % reset];

        var point2 = {};
        point2.x = currentMesh[(index + 2) % reset];
        point2.y = currentMesh[(index + 3) % reset];

        var point3 = {};
        point3.x = currentMesh[(index + 4) % reset];
        point3.y = currentMesh[(index + 5) % reset];

        var ant = isFold(point1, point2);
        var next = isFold(point2, point3);
        var angle = getAngle(point1, point2, point3);

        var insert;
        var bezier;

        if (ant == true) {
          if (next == true) {
            //fold & fold

            if (getFoldDirection(point2, point3) === 'Out') {
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
            } else if (angle < Math.PI) {
              //fold & fold & smaller
              insert = getCoordOnCorner(point1, point2, point3, thickness, angle, false);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);
            } else if (angle > Math.PI) {
              //fold & fold & larger
              insert = getCoordOnCorner(point1, point2, point3, thickness, angle, true);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);
            } else {
              //fold & fold & 180
              insert = getCoordOnCorner(point1, point2, point3, thickness, angle, false);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);
            }
          } else {
            //fold & cut

            if (getFoldDirection(point1, point2) === 'Out') {
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
            } else if (angle < Math.PI) {
              //fold & cut & smaller
              insert = getCoordOnLine(point2, point3, thickness);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);
            } else if (angle > Math.PI) {
              //fold & cut & larger
              insert = getCoordOnLine(point2, point3, thickness, false);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);
            } else {
              //fold & cut & 180
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: point2,
              };
              curvePoints[name].push(bezier);
            }
          }
        } else {
          if (next == true) {
            //cut & fold

            if (getFoldDirection(point2, point3) === 'Out') {
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
            } else if (angle < Math.PI) {
              //cut & fold & smaller
              insert = getCoordOnLine(point2, point1, thickness);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);
            } else if (angle > Math.PI) {
              //cut & fold & larger
              insert = getCoordOnLine(point2, point1, thickness, false);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);
            } else {
              //cut & fold & 180
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: thickness,
                  z: point2.y,
                },
                destination: point2,
              };
              curvePoints[name].push(bezier);
            }
          } else {
            //cut & cut
            newPoints[name].push(point2.x);
            newPoints[name].push(point2.y);
          }
        }
      }

      newPoints[name].unshift(newPoints[name].pop());
      newPoints[name].unshift(newPoints[name].pop());
    }
    var parent = 0;
    for (var index in newPoints) {
      var indici = [];
      var puncte = [];
      var uv = [];
      var normals = [];

      for (var i = 0; i < newPoints[index].length; i += 2) {
        //PUNCTE
        puncte.push(newPoints[index][i]);
        puncte.push(thickness);
        puncte.push(newPoints[index][i + 1]);

        //INDICI
        if ((i + 1) % 2 != 0) {
          indici.push(parseInt(i / 2));
        }

        //UVs
        var u = 1 - (newPoints[index][i] - UVdimension['p2']['x'] + parseFloat(points.svgDim.margin)) / w; //lungime
        var v = (newPoints[index][i + 1] - UVdimension['p2']['y'] + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

        uv.push(u);
        uv.push(-v);
        normals.push(new BABYLON.Vector3(0, 0, -1));
      } // PUNCTE INDICI UV

      var earcut_points = newPoints[index];
      indici = earcut(earcut_points);

      var vertexData = new BABYLON.VertexData();
      BABYLON.VertexData.ComputeNormals(puncte, indici, normals);
      vertexData.positions = puncte;
      vertexData.indices = indici;
      vertexData.uvs = uv;
      vertexData.normals = normals;

      var meshName = new BABYLON.Mesh(name_array[parent++], scene);

      vertexData.applyToMesh(meshName);
      meshName.material = FaceMaterial;
    }
  };

  var createMeshesCopyAdvanced = function () {
    var UVdimension = [];

    UVdimension['p1'] = [];
    UVdimension['p1']['x'] = max_x;
    UVdimension['p1']['y'] = max_y;

    UVdimension['p2'] = [];
    UVdimension['p2']['x'] = min_x;
    UVdimension['p2']['y'] = min_y;

    var w = Math.abs(max_x - min_x);
    var h = Math.abs(max_y - min_y);

    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['width'] !== 'undefined') {
        w = points['svgDim']['width'];
      }
    }
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['height'] !== 'undefined') {
        h = points['svgDim']['height'];
      }
    }

    var newPoints = [];

    for (var name in points['points']) {
      newPoints[name] = [];
      sideMeshes[name] = [];
      var currentMesh = points['points'][name];
      var reset = currentMesh.length;
      for (var index = 0; index < currentMesh.length; index += 2) {
        var point1 = {};
        point1.x = currentMesh[index % reset];
        point1.y = currentMesh[(index + 1) % reset];

        var point2 = {};
        point2.x = currentMesh[(index + 2) % reset];
        point2.y = currentMesh[(index + 3) % reset];

        var point3 = {};
        point3.x = currentMesh[(index + 4) % reset];
        point3.y = currentMesh[(index + 5) % reset];

        var ant = isFold(point1, point2);
        var next = isFold(point2, point3);
        var angle = getAngle(point1, point2, point3);

        var insert;
        var bezier;

        if (ant == true) {
          if (next == true) {
            //fold & fold

            if (getFoldDirection(point2, point3) !== 'Out') {
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
              createSideCoords(point2, point2, name);
            } else if (angle < Math.PI) {
              //fold & fold & smaller
              insert = getCoordOnCorner(point1, point2, point3, thickness, angle, false);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);

              createSideCoords(insert, point2, name);
            } else if (angle > Math.PI) {
              //fold & fold & larger
              insert = getCoordOnCorner(point1, point2, point3, thickness, angle, true);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);

              createSideCoords(insert, point2, name);
            } else {
              //fold & fold & 180
              insert = getCoordOnCorner(point1, point2, point3, thickness, angle, false);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);

              createSideCoords(insert, point2, name);
            }
          } else {
            //fold & cut

            if (getFoldDirection(point1, point2) !== 'Out') {
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
              createSideCoords(point2, point2, name);
            } else if (angle < Math.PI) {
              //fold & cut & smaller
              insert = getCoordOnLine(point2, point3, thickness);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);

              createSideCoords(insert, point2, name);
            } else if (angle > Math.PI) {
              //fold & cut & larger
              insert = getCoordOnLine(point2, point3, thickness, false);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);

              createSideCoords(insert, point2, name);
            } else {
              //fold & cut & 180
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: point2,
              };
              curvePoints[name].push(bezier);

              createSideCoords(point2, point2, name);
            }
          }
        } else {
          if (next == true) {
            //cut & fold

            if (getFoldDirection(point2, point3) !== 'Out') {
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
              createSideCoords(point2, point2, name);
            } else if (angle < Math.PI) {
              //cut & fold & smaller
              insert = getCoordOnLine(point2, point1, thickness);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);

              createSideCoords(insert, point2, name);
            } else if (angle > Math.PI) {
              //cut & fold & larger
              insert = getCoordOnLine(point2, point1, thickness, false);
              newPoints[name].push(insert.x);
              newPoints[name].push(insert.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: insert,
              };
              curvePoints[name].push(bezier);

              createSideCoords(insert, point2, name);
            } else {
              //cut & fold & 180
              newPoints[name].push(point2.x);
              newPoints[name].push(point2.y);
              bezier = {
                origin: point2,
                control: {
                  x: point2.x,
                  y: 0,
                  z: point2.y,
                },
                destination: point2,
              };
              curvePoints[name].push(bezier);

              createSideCoords(point2, point2, name);
            }
          } else {
            //cut & cut
            newPoints[name].push(point2.x);
            newPoints[name].push(point2.y);

            createSideCoords(point2, point2, name);
          }
        }
      }

      newPoints[name].unshift(newPoints[name].pop());
      newPoints[name].unshift(newPoints[name].pop());
    }
    small_area_points = newPoints;

    for (var index in newPoints) {
      var indici = [];
      var puncte = [];
      var uv = [];
      var normals = [];

      for (var i = 0; i < newPoints[index].length; i += 2) {
        //PUNCTE
        puncte.push(newPoints[index][i]);
        puncte.push(0);
        puncte.push(newPoints[index][i + 1]);

        //INDICI
        if ((i + 1) % 2 != 0) {
          indici.push(parseInt(i / 2));
        }

        //UVs
        var u = (newPoints[index][i] - UVdimension['p2']['x'] + parseFloat(points.svgDim.margin)) / w; //lungime
        var v = (newPoints[index][i + 1] - UVdimension['p2']['y'] + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

        uv.push(u);
        uv.push(-v);
        normals.push(new BABYLON.Vector3(0, 0, -1));
      }
      // PUNCTE INDICI UV

      var earcut_points = newPoints[index];
      indici = earcut(earcut_points);

      var vertexData = new BABYLON.VertexData();
      BABYLON.VertexData.ComputeNormals(puncte, indici, normals);
      vertexData.positions = puncte;
      vertexData.indices = indici;
      vertexData.uvs = uv;
      vertexData.normals = normals;

      var meshName = new BABYLON.Mesh(name_array[index] + '_copy', _scene);

      vertexData.applyToMesh(meshName);
      meshName.material = BackMaterial;

      meshName.flipFaces(true);

      var meshName_vertices = meshName.getTotalVertices();
      var meshName_indices = meshName.getTotalIndices();

      var mesh0_vertices = _scene.meshes[0].getTotalVertices();
      var mesh0_indices = _scene.meshes[0].getTotalIndices();

      var merge = BABYLON.Mesh.MergeMeshes([_scene.meshes[0], meshName], true);

      _scene.meshes.push(scene.meshes.shift());

      var multimat = new BABYLON.MultiMaterial('multi', _scene);
      multimat.subMaterials.push(FaceMaterial);
      multimat.subMaterials.push(BackMaterial);

      merge.material = multimat;

      merge.subMeshes = [];

      merge.subMeshes.push(new BABYLON.SubMesh(0, 0, mesh0_vertices, 0, mesh0_indices, merge));
      merge.subMeshes.pop();
      merge.subMeshes.push(new BABYLON.SubMesh(1, mesh0_vertices, meshName_vertices, mesh0_indices, meshName_indices, merge));
      merge.subMeshes.pop();
    }
  };

  var createCurveAdvanced = function () {
    var numberOfPoints = 8;
    var w = Math.abs(max_x - min_x);
    var h = Math.abs(max_y - min_y);
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['width'] !== 'undefined') {
        w = points['svgDim']['width'];
      }
    }
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['height'] !== 'undefined') {
        h = points['svgDim']['height'];
      }
    }
    var parent = 0;
    for (var name in curvePoints) {
      curveSides[name] = [];
      if (curvePoints[name].length > 0) {
        var reset = curvePoints[name].length;
        for (var parser = 0; parser < curvePoints[name].length; parser++) {
          var coords1 = curvePoints[name][parser];
          var coords2 = curvePoints[name][(parser + 1) % reset];

          if (isFold(coords1.origin, coords2.origin) && reset > 2) {
            if (getFoldDirection(coords1.origin, coords2.origin) === 'Out') {
              var quadraticBezierVectors = BABYLON.Curve3.CreateQuadraticBezier(
                new BABYLON.Vector3(coords1.destination.x, 0, coords1.destination.y),
                new BABYLON.Vector3(coords1.control.x, coords1.control.y, coords1.control.z),
                new BABYLON.Vector3(coords1.origin.x, thickness, coords1.origin.y),

                numberOfPoints
              );
              var curve1 = quadraticBezierVectors.getPoints();

              var quadraticBezierVectors2 = BABYLON.Curve3.CreateQuadraticBezier(
                new BABYLON.Vector3(coords2.destination.x, 0, coords2.destination.y),
                new BABYLON.Vector3(coords2.control.x, coords2.control.y, coords2.control.z),
                new BABYLON.Vector3(coords2.origin.x, thickness, coords2.origin.y),

                numberOfPoints
              );

              var curve2 = quadraticBezierVectors2.getPoints();

              var finalCurve = [];

              for (var i = 0; i < curve1.length; i++) {
                finalCurve.push(curve1[i].x);
                finalCurve.push(curve1[i].y);
                finalCurve.push(curve1[i].z);
              }
              for (var i = 0; i < curve2.length; i++) {
                finalCurve.push(curve2[i].x);
                finalCurve.push(curve2[i].y);
                finalCurve.push(curve2[i].z);
              }

              var indici = [];
              var next = curve1.length;
              for (var i = 0; i < curve1.length - 1; i++) {
                indici.push(i);
                indici.push(i + next);
                indici.push(i + next + 1);
                indici.push(i + next + 1);
                indici.push(i + 1);
                indici.push(i);
              }

              var finalCurve_no_y = [];

              var uv = [];
              var normals = [];
              for (var i = 0; i < finalCurve.length - 1; i += 3) {
                finalCurve_no_y.push(finalCurve[i]);
                finalCurve_no_y.push(finalCurve[i + 2]);

                //UVs
                var u = (finalCurve[i] - min_x + parseFloat(points.svgDim.margin)) / w; //lungime
                var v = (finalCurve[i + 2] - min_y + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

                uv.push(u);
                uv.push(-v);
                normals.push(new BABYLON.Vector3(0, 0, -1));
              }

              // PUNCTE INDICI UV

              var vertexData = new BABYLON.VertexData();
              BABYLON.VertexData.ComputeNormals(finalCurve, indici, normals);
              vertexData.positions = finalCurve;
              vertexData.indices = indici;
              vertexData.uvs = uv;
              vertexData.normals = normals;

              var meshName = new BABYLON.Mesh(scene.meshes[parent].name + '_curve', scene);

              vertexData.applyToMesh(meshName);
              meshName.material = BackMaterial;
              meshName.flipFaces(true);
              meshName.parent = scene.meshes[parent];

              createCurveSide(curve1, parent, name);
              createCurveSide(curve2, parent, name);
            } else if (getFoldDirection(coords1.origin, coords2.origin) === 'In') {
              var quadraticBezierVectors = BABYLON.Curve3.CreateQuadraticBezier(
                new BABYLON.Vector3(coords1.destination.x, thickness, coords1.destination.y),
                new BABYLON.Vector3(coords1.origin.x, thickness, coords1.origin.y),
                new BABYLON.Vector3(coords1.origin.x, 0, coords1.origin.y),

                numberOfPoints
              );
              var curve1 = quadraticBezierVectors.getPoints();

              var quadraticBezierVectors2 = BABYLON.Curve3.CreateQuadraticBezier(
                new BABYLON.Vector3(coords2.destination.x, thickness, coords2.destination.y),
                new BABYLON.Vector3(coords2.origin.x, thickness, coords2.origin.y),
                new BABYLON.Vector3(coords2.origin.x, 0, coords2.origin.y),

                numberOfPoints
              );

              var curve2 = quadraticBezierVectors2.getPoints();

              var finalCurve = [];

              for (var i = 0; i < curve1.length; i++) {
                finalCurve.push(curve1[i].x);
                finalCurve.push(curve1[i].y);
                finalCurve.push(curve1[i].z);
              }
              for (var i = 0; i < curve2.length; i++) {
                finalCurve.push(curve2[i].x);
                finalCurve.push(curve2[i].y);
                finalCurve.push(curve2[i].z);
              }

              var indici = [];
              var next = curve1.length;
              for (var i = 0; i < curve1.length - 1; i++) {
                indici.push(i);
                indici.push(i + next);
                indici.push(i + next + 1);
                indici.push(i + next + 1);
                indici.push(i + 1);
                indici.push(i);
              }

              var finalCurve_no_y = [];

              var uv = [];
              var normals = [];
              for (var i = 0; i < finalCurve.length - 1; i += 3) {
                finalCurve_no_y.push(finalCurve[i]);
                finalCurve_no_y.push(finalCurve[i + 2]);

                //UVs
                var u = (finalCurve[i] - min_x + parseFloat(points.svgDim.margin)) / w; //lungime
                var v = (finalCurve[i + 2] - min_y + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

                uv.push(u);
                uv.push(-v);
                normals.push(new BABYLON.Vector3(0, 0, -1));
              }

              // PUNCTE INDICI UV

              var vertexData = new BABYLON.VertexData();
              BABYLON.VertexData.ComputeNormals(finalCurve, indici, normals);
              vertexData.positions = finalCurve;
              vertexData.indices = indici;
              vertexData.uvs = uv;
              vertexData.normals = normals;

              var meshName = new BABYLON.Mesh(scene.meshes[parent].name + '_curve', scene);

              vertexData.applyToMesh(meshName);
              meshName.material = FaceMaterial;
              meshName.parent = scene.meshes[parent];

              createCurveSide(curve1, parent, name);
              createCurveSide(curve2, parent, name);
            }
          } else if (isFold(coords1.origin, coords2.origin) && reset === 2) {
            if (getFoldDirection(coords1.origin, coords2.origin) === 'Out') {
              var quadraticBezierVectors = BABYLON.Curve3.CreateQuadraticBezier(
                new BABYLON.Vector3(coords1.destination.x, 0, coords1.destination.y),
                new BABYLON.Vector3(coords1.control.x, coords1.control.y, coords1.control.z),
                new BABYLON.Vector3(coords1.origin.x, thickness, coords1.origin.y),

                numberOfPoints
              );
              var curve1 = quadraticBezierVectors.getPoints();

              var quadraticBezierVectors2 = BABYLON.Curve3.CreateQuadraticBezier(
                new BABYLON.Vector3(coords2.destination.x, 0, coords2.destination.y),
                new BABYLON.Vector3(coords2.control.x, coords2.control.y, coords2.control.z),
                new BABYLON.Vector3(coords2.origin.x, thickness, coords2.origin.y),

                numberOfPoints
              );

              var curve2 = quadraticBezierVectors2.getPoints();

              var finalCurve = [];

              for (var i = 0; i < curve1.length; i++) {
                finalCurve.push(curve1[i].x);
                finalCurve.push(curve1[i].y);
                finalCurve.push(curve1[i].z);
              }
              for (var i = 0; i < curve2.length; i++) {
                finalCurve.push(curve2[i].x);
                finalCurve.push(curve2[i].y);
                finalCurve.push(curve2[i].z);
              }

              var indici = [];
              var next = curve1.length;
              for (var i = 0; i < curve1.length - 1; i++) {
                indici.push(i);
                indici.push(i + next);
                indici.push(i + next + 1);
                indici.push(i + next + 1);
                indici.push(i + 1);
                indici.push(i);
              }

              var finalCurve_no_y = [];

              var uv = [];
              var normals = [];
              for (var i = 0; i < finalCurve.length - 1; i += 3) {
                finalCurve_no_y.push(finalCurve[i]);
                finalCurve_no_y.push(finalCurve[i + 2]);

                //UVs
                var u = (finalCurve[i] - min_x + parseFloat(points.svgDim.margin)) / w; //lungime
                var v = (finalCurve[i + 2] - min_y + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

                uv.push(u);
                uv.push(-v);
                normals.push(new BABYLON.Vector3(0, 0, -1));
              }

              // PUNCTE INDICI UV

              var vertexData = new BABYLON.VertexData();
              BABYLON.VertexData.ComputeNormals(finalCurve, indici, normals);
              vertexData.positions = finalCurve;
              vertexData.indices = indici;
              vertexData.uvs = uv;
              vertexData.normals = normals;

              var meshName = new BABYLON.Mesh(scene.meshes[parent].name + '_curve', scene);

              vertexData.applyToMesh(meshName);
              meshName.material = BackMaterial;
              meshName.parent = scene.meshes[parent];

              createCurveSide(curve1, parent, name);
              createCurveSide(curve2, parent, name);
            } else if (getFoldDirection(coords1.origin, coords2.origin) === 'In') {
              var quadraticBezierVectors = BABYLON.Curve3.CreateQuadraticBezier(
                new BABYLON.Vector3(coords1.destination.x, thickness, coords1.destination.y),
                new BABYLON.Vector3(coords1.origin.x, thickness, coords1.origin.y),
                new BABYLON.Vector3(coords1.origin.x, 0, coords1.origin.y),

                numberOfPoints
              );
              var curve1 = quadraticBezierVectors.getPoints();

              var quadraticBezierVectors2 = BABYLON.Curve3.CreateQuadraticBezier(
                new BABYLON.Vector3(coords2.destination.x, thickness, coords2.destination.y),
                new BABYLON.Vector3(coords2.origin.x, thickness, coords2.origin.y),
                new BABYLON.Vector3(coords2.origin.x, 0, coords2.origin.y),

                numberOfPoints
              );

              var curve2 = quadraticBezierVectors2.getPoints();

              var finalCurve = [];

              for (var i = 0; i < curve1.length; i++) {
                finalCurve.push(curve1[i].x);
                finalCurve.push(curve1[i].y);
                finalCurve.push(curve1[i].z);
              }
              for (var i = 0; i < curve2.length; i++) {
                finalCurve.push(curve2[i].x);
                finalCurve.push(curve2[i].y);
                finalCurve.push(curve2[i].z);
              }

              var indici = [];
              var next = curve1.length;
              for (var i = 0; i < curve1.length - 1; i++) {
                indici.push(i);
                indici.push(i + next);
                indici.push(i + next + 1);
                indici.push(i + next + 1);
                indici.push(i + 1);
                indici.push(i);
              }

              var finalCurve_no_y = [];

              var uv = [];
              var normals = [];
              for (var i = 0; i < finalCurve.length - 1; i += 3) {
                finalCurve_no_y.push(finalCurve[i]);
                finalCurve_no_y.push(finalCurve[i + 2]);

                //UVs
                var u = (finalCurve[i] - min_x + parseFloat(points.svgDim.margin)) / w; //lungime
                var v = (finalCurve[i + 2] - min_y + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

                uv.push(u);
                uv.push(-v);
                normals.push(new BABYLON.Vector3(0, 0, -1));
              }

              // PUNCTE INDICI UV

              var vertexData = new BABYLON.VertexData();
              BABYLON.VertexData.ComputeNormals(finalCurve, indici, normals);
              vertexData.positions = finalCurve;
              vertexData.indices = indici;
              vertexData.uvs = uv;
              vertexData.normals = normals;

              var meshName = new BABYLON.Mesh(scene.meshes[parent].name + '_curve', scene);

              vertexData.applyToMesh(meshName);
              meshName.material = FaceMaterial;
              meshName.parent = scene.meshes[parent];

              createCurveSide(curve1, parent, name);
              createCurveSide(curve2, parent, name);
            }
            break;
          }
        }
      }
      parent++;
    }
  };

  var createParentsAdvanced = function () {
    var parents_index = [];

    for (var name in points['points']) {
      if (typeof points['points'][name][0] != 'string') {
        points['points'][name].unshift('noParent');
      }
      parents_index.push(points['points'][name][0]);
    }

    var copy_;
    // PARENTS FOR EACH MESH
    for (var pars = 0; pars < name_array.length; pars++) {
      if (meshesParents[pars] != 'noParent') {
        for (var index in _scene.meshes) {
          if (meshesParents[pars] == _scene.meshes[index].name.replace('_merged', '')) {
            copy_ = _scene.meshes[index];
            break;
          }
        }
        _scene.meshes[pars].parent = copy_;
      }
    }
  };

  var createPivotAxisAdvanced = function () {
    for (var name in points['points']) {
      if (typeof points['points'][name][0] === 'string') {
        points['points'][name].shift();
      }
    }

    for (var index = 0; index < name_array.length; index++) {
      var name = _scene.meshes[index].name.replace('_merged', '');

      var pivotx = points['axis'][name]['pivot']['x'];
      var pivoty = points['axis'][name]['pivot']['y'];

      var vx_ = points['axis'][name]['target']['x'];
      var vz_ = points['axis'][name]['target']['y'];

      var vx = vx_ - pivotx;
      var vz = vz_ - pivoty;

      var mv = Math.sqrt(Math.pow(vx, 2) + Math.pow(vz, 2)); //magnitude
      var quaternion = [vx / mv, 0, vz / mv];

      Engine3DVariables.meshes[name].axis.quaternion = [];
      Engine3DVariables.meshes[name].axis.quaternion[0] = quaternion[0];
      Engine3DVariables.meshes[name].axis.quaternion[1] = 0;
      Engine3DVariables.meshes[name].axis.quaternion[2] = quaternion[2];

      if (Engine3DVariables.meshes[name].fold == 'Out') {
        window.scene.meshes[index].setPivotMatrix(BABYLON.Matrix.Translation(-pivotx, -thickness, -pivoty), true);
      } else {
        window.scene.meshes[index].setPivotMatrix(BABYLON.Matrix.Translation(-pivotx, 0, -pivoty), true);
      }

      _scene.meshes[index].name = name;
    }
  };

  var createSidesAdvanced = function () {
    var k = 0;
    var toMerge = [];
    var w = Math.abs(max_x - min_x);
    var h = Math.abs(max_y - min_y);
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['width'] !== 'undefined') {
        w = points['svgDim']['width'];
      }
    }
    if (typeof points['svgDim'] !== 'undefined') {
      if (typeof points['svgDim']['height'] !== 'undefined') {
        h = points['svgDim']['height'];
      }
    }

    for (var name in sideMeshes) {
      var sidePoints = [];
      var reset = sideMeshes[name].length;
      for (var index = 0; index < sideMeshes[name].length; index++) {
        var point1 = sideMeshes[name][index % reset];
        var point2 = sideMeshes[name][(index + 1) % reset];

        if (!isFold(point1.initial, point2.initial)) {
          sidePoints.push(point1.final.x);
          sidePoints.push(0);
          sidePoints.push(point1.final.y); //z

          sidePoints.push(point1.final.x);
          sidePoints.push(thickness);
          sidePoints.push(point1.final.y); //z

          sidePoints.push(point2.final.x);
          sidePoints.push(thickness);
          sidePoints.push(point2.final.y); //z

          sidePoints.push(point2.final.x);
          sidePoints.push(thickness);
          sidePoints.push(point2.final.y); //z

          sidePoints.push(point2.final.x);
          sidePoints.push(0);
          sidePoints.push(point2.final.y); //z

          sidePoints.push(point1.final.x);
          sidePoints.push(0);
          sidePoints.push(point1.final.y); //z

          var uv = [];
          var normals = [];
          for (var i = 0; i < sidePoints.length - 1; i += 3) {
            //UVs
            var u = (sidePoints[i] - min_x + parseFloat(points.svgDim.margin)) / w; //lungime
            var v = (sidePoints[i + 2] - min_y + parseFloat(points.svgDim.margin)) / h + 1; //inaltime

            uv.push(u);
            uv.push(-v);
            normals.push(new BABYLON.Vector3(0, 0, -1));
          } // PUNCTE INDICI UV

          var earcut_points = sidePoints;
          var indici = earcut(earcut_points, null, 3);
          indici = [4, 0, 1, 4, 1, 3]; // TODO: hardcoded
          var vertexData = new BABYLON.VertexData();
          BABYLON.VertexData.ComputeNormals(sidePoints, indici, normals);
          vertexData.positions = sidePoints;
          vertexData.indices = indici;
          vertexData.uvs = uv;
          vertexData.normals = normals;

          var meshName = new BABYLON.Mesh(scene.meshes[k].name + '_side_plane', scene);

          vertexData.applyToMesh(meshName);
          meshName.material = CartonMaterial;
          meshName.parent = scene.meshes[k];
          sidePoints = [];

          toMerge.push(meshName);
        }
      }
      if (toMerge.length > 0) {
        var newMesh = BABYLON.Mesh.MergeMeshes(toMerge, true);
        toMerge = [];
        newMesh.parent = scene.meshes[k];
        newMesh.isPickable = false;
      }
      toMerge = [];
      k++;
    }
  };

  var updateMeshesAdvanced = function (result) {
    points = result.points_only;
    prevPoints = points;

    while (_scene.meshes.length != 0) {
      _scene.meshes[0].dispose();
    }

    meshesParents = [];
    curves_count = 0;
    axisPoints = [];
    puncte_finale_sus = [];
    puncte_finale_jos = [];
    puncte_finale_sides = [];
    name_array = [];
    curve_parent = [];
    uvsCurve = [];
    toBuild_no_y = [];

    name_array = [];
    axisPoints = [];
    uvsCurve = [];

    min_x = Infinity;
    min_y = Infinity;
    max_x = -Infinity;
    max_y = -Infinity;

    createAxisPointsAdvanced();

    createMeshesAdvanced();

    createMeshesCopyAdvanced();

    createCurveAdvanced();

    createParentsAdvanced();

    createPivotAxisAdvanced();

    if (fluteType !== 'default' && Engine3DVariables.enableCorrugation === 1) {
      corrugatedBoard();
    } else {
      createSidesAdvanced();
    }

    optimizeModel();
  };

  function MyLoadingScreen(text) {
    //init the loader
    this.loadingUIText = text;
  }

  MyLoadingScreen.prototype.displayLoadingUI = function () {
    //alert(this.loadingUIText);
    return;
  };

  MyLoadingScreen.prototype.hideLoadingUI = function () {
    //alert("Loaded!");
    return;
  };

  function Engine3D(element, formElement, variables) {
    this.element = $(element);
    this.formElement = $(formElement);
    this.data = variables.close_data;
    this.close_data = variables.close_data;
    this.meshes = variables.meshes;
    this.cameraSettings = variables.cameraSettings;
    this.animations = variables.animations;
    this.meshNames = variables.meshNames;
    this.animationButtons = $('.animation-button');
    this.flipButton = $('.flip-button');
    this.babylon = null;
    this.paramsStorage = {};
    this.reloadStorage = {};
    this.working = 0;
    var maxStage = 0;
    var minStage = 0;
    var stages = Object.keys(Engine3DVariables.animations);
    var startStage = Engine3DVariables.cameraSettings.animationStart ? parseInt(Engine3DVariables.cameraSettings.animationStart) : 0;
    for (var stage in stages) {
      var tmp = stages[stage].split(' ');
      stage = parseInt(tmp[1]);
      if (stage > maxStage) {
        maxStage = stage;
      }
      if (stage < minStage) {
        minStage = stage;
      }
    }
    //make sure startStage is between min and max
    if (startStage > maxStage) {
      startStage = maxStage;
    }
    if (startStage < minStage) {
      startStage = minStage;
    }
    this.animation = {
      status: 0,
      state: 'next',
      stage: startStage,
      maxstage: maxStage,
      minstage: minStage,
    };
    this.previousList = {};
    this.animValues = [];
  }

  Engine3D.prototype = {
    constructor: Engine3D,
    loading: function (flag) {
      loaded = !flag;
      var loading = $('#loadingMask');
      var body = $('body');
      if (flag) {
        body.addClass('loading');
        loading.show();
      } else {
        body.removeClass('loading');
        loading.hide();
        if (!Object.keys(this.paramsStorage).length == 0) {
          this.changeParams(this.paramsStorage);
          this.paramsStorage = {};
        }
        if (onMessageStorage.length !== 0) {
          window.postMessage(onMessageStorage, '*');
          onMessageStorage = '';
        }
      }
    },
    loadModel: function () {
      this.babylon = new BabylonModel(this.element.get(0), this);
      this.initForm();
      this.babylon.startScene(() => {
        this.babylon.initScene();
        this.babylon.initGlassMat('Glass');
        this.babylon.changeCameraTarget();
        this.initAnimationButtons();
        this.babylon.changeInitialTexture();
        this.executeAnimation(this.animation.stage, 'init', 1);
        if (enableHighlight === true) {
          initHighlight();
        }
        this.loading(false);
      });
    },
    changeAnimationState: function (state, initial) {
      if (animation_running) {
        return 0;
      }

      this.animation.state = state;
      var tmp = this.animation.stage;
      var previousStage = this.animation.stage;
      var init = 0;

      if (typeof initial != 'undefined' && initial) init = 0;

      if (init) this.data = this.close_data;
      if (state == 'next') {
        tmp++;
        if (tmp > this.animation.maxstage) return;
        this.animation.stage = tmp;
      }
      if (state == 'previous') {
        tmp--;
        if (tmp < this.animation.minstage) return;
        this.animation.stage = tmp;
      }

      this.executeAnimation(this.animation.stage, previousStage, 0);
      if (init) this.importMeshes();
    },
    executeAnimation: function (stage, previousStage, noAnimation) {
      if (animation_running) {
        return 0;
      }
      var reverse = stage < previousStage;
      if (!reverse) {
        var list = this.getModelAnimation(stage, this.animation.minstage);
      } else {
        var list = this.getModelAnimation(stage + 1, this.animation.minstage);
      }

      if (previousStage == 'init') {
        for (var index in Engine3DVariables.meshNames) {
          var mesh = scene.getMeshByName(Engine3DVariables.meshNames[index]);
          this.previousList[Engine3DVariables.meshNames[index]] = {};
          this.previousList[Engine3DVariables.meshNames[index]]['position'] = {};
          this.previousList[Engine3DVariables.meshNames[index]]['rotation'] = {};
          this.previousList[Engine3DVariables.meshNames[index]]['position']['x'] = mesh.position.x;
          this.previousList[Engine3DVariables.meshNames[index]]['position']['y'] = mesh.position.y;
          this.previousList[Engine3DVariables.meshNames[index]]['position']['z'] = mesh.position.z;
          this.previousList[Engine3DVariables.meshNames[index]]['rotation']['end'] = '0';
          this.previousList[Engine3DVariables.meshNames[index]]['rotation']['lastSeen'] = '0.0';
        }
        previousStage = stage - 1;
        var first = 1;
        for (var stageTmp in Engine3DVariables.animations) {
          var stageInt = stageTmp.split(' ');
          stageInt = parseInt(stageInt[1]);
          if (typeof this.animValues[stageInt] == 'undefined') this.animValues[stageInt] = [];
          for (var stepTmp in Engine3DVariables.animations[stageTmp]) {
            var stepInt = stepTmp.split(' ');
            stepInt = parseInt(stepInt[1]);
            if (typeof this.animValues[stageInt][stepInt] == 'undefined') {
              this.animValues[stageInt][stepInt] = [];
              this.animValues[stageInt][stepInt]['Rotation'] = [];
              this.animValues[stageInt][stepInt]['Position'] = [];
            }
            var valRot = Engine3DVariables.animations[stageTmp][stepTmp]['Rotation'];
            var valPos = Engine3DVariables.animations[stageTmp][stepTmp]['Position'];
            for (index in Engine3DVariables.meshNames) {
              var name = Engine3DVariables.meshNames[index];
              if (typeof this.animValues[stageInt][stepInt]['Rotation'][name] == 'undefined') this.animValues[stageInt][stepInt]['Rotation'][name] = [];

              if (typeof this.animValues[stageInt][stepInt]['Position'][name] == 'undefined') this.animValues[stageInt][stepInt]['Position'][name] = [];

              var lastSeen = {};
              lastSeen = {
                stage: stageInt.toString(),
                step: stepInt.toString(),
              };

              var lastSeenPos = {};
              lastSeenPos = {
                stage: stageInt.toString(),
                step: stepInt.toString(),
              };

              if (first) {
                if (typeof valRot[name] == 'undefined') {
                  lastSeen.value = '0';
                } else {
                  lastSeen.value = valRot[name];
                }
              } else {
                if (typeof valRot[name] == 'undefined') {
                  var split = this.previousList[name]['rotation']['lastSeen'].split('.');
                  var tmpstage = parseInt(split[0]);
                  var tmpstep = parseInt(split[1]);
                  lastSeen.value = this.animValues[tmpstage][tmpstep]['Rotation'][name]['end'];
                } else {
                  lastSeen.value = valRot[name];
                }
              }
              this.animValues[stageInt][stepInt]['Rotation'][name]['end'] = lastSeen.value;
              this.previousList[name]['rotation']['lastSeen'] = lastSeen.stage + '.' + lastSeen.step;

              if (first) {
                if (typeof valPos != 'undefined') {
                  if (typeof valPos[name] == 'undefined') {
                    lastSeenPos.value = Engine3DVariables.meshNames[index]['position'];
                  } else {
                    lastSeenPos.value = valPos[name];
                  }
                }
              } else {
                if (typeof valPos != 'undefined') {
                  if (typeof valPos[name] == 'undefined') {
                    var split = this.previousList[name]['position']['lastSeen'].split('.');
                    var tmpstage = parseInt(split[0]);
                    var tmpstep = parseInt(split[1]);
                    lastSeenPos.value = this.animValues[tmpstage][tmpstep]['Position'][name];
                  } else {
                    lastSeenPos.value = valPos[name];
                  }
                } else {
                  var split = this.previousList[name]['position']['lastSeen'].split('.');
                  var tmpstage = parseInt(split[0]);
                  var tmpstep = parseInt(split[1]);
                  lastSeenPos.value = this.animValues[tmpstage][tmpstep]['Position'][name];
                }
              }
              if (typeof lastSeenPos.value == 'undefined' && first == 1) {
                lastSeenPos.value = {
                  x: this.previousList[Engine3DVariables.meshNames[index]]['position']['x'].toString(),
                  y: this.previousList[Engine3DVariables.meshNames[index]]['position']['y'].toString(),
                  z: this.previousList[Engine3DVariables.meshNames[index]]['position']['z'].toString(),
                };
              }
              this.animValues[stageInt][stepInt]['Position'][name] = lastSeenPos.value;
              this.previousList[name]['position']['lastSeen'] = lastSeenPos.stage + '.' + lastSeenPos.step;
            }
            first = 0;
          }
        }
      }
      this.babylon.animation(stage, this.animValues, {
        reverse: reverse,
        noAnimation: noAnimation,
      });
    },
    getModelAnimation: function (stage, minstage) {
      var result = {};
      var strStage = 'Stage ' + stage;
      $.each(
        Engine3DVariables.animations[strStage],
        (function (result, stage) {
          return function (step, data) {
            var step = step.split(' ');
            step = parseInt(step[1]);
            result[step] = {};
            if (data.hasOwnProperty('Rotation')) {
              var rotation = data['Rotation'];
              for (name in rotation) {
                if (stage < minstage) {
                  result[step][name] = {
                    stage: '0',
                    noAnimation: 1,
                    end: '0',
                  };
                } else {
                  if (typeof result[step][name] == 'undefined') {
                    result[step][name] = {};
                  }
                  result[step][name]['rotation'] = {};
                  result[step][name]['rotation']['end'] = rotation[name];
                }
              }
            }
            if (data.hasOwnProperty('Position')) {
              var position = data['Position'];
              for (name in position) {
                if (stage < minstage) {
                  result[step][name] = {
                    stage: '0',
                    noAnimation: 1,
                    x: '0',
                    y: '0',
                    z: '0',
                  };
                } else {
                  if (typeof result[step][name] == 'undefined') {
                    result[step][name] = {};
                  }
                  result[step][name]['position'] = {};
                  result[step][name]['position']['x'] = position[name]['x'];
                  result[step][name]['position']['y'] = position[name]['y'];
                  result[step][name]['position']['z'] = position[name]['z'];
                }
              }
            }
          };
        })(result, stage)
      );
      return result;
    },
    flipMesh: function (state) {
      this.babylon.flipMesh(this.animation);
    },
    initForm: function () {
      this.formElement.submit(
        (function (that) {
          return function (e) {
            e.preventDefault();
            that.changeParams($(this).serializeArray());
          };
        })(this)
      );
    },
    reloadModel: function (params) {
      if (!params && this.reloadStorage) {
        params = this.reloadStorage;
      }
      this.loading(true);
      var that = this;
      if (!that.working) {
        that.working = 1;
        var data = params;
        var success = (function (that, params) {
          return function (result) {
            if (result.hasOwnProperty('stats') && result.stats == 'fail') return;
            that.close_data = result.close_data;
            that.meshes = result.meshes;
            that.cameraTarget = result.cameraTarget;
            Engine3DVariables.thickness = result.thickness;
            Engine3DVariables.fluteType = result.fluteType;
            setFluteType(Engine3DVariables.fluteType);

            Engine3DVariables.cameraTarget = result.cameraTarget;
            variables = result.variables;

            that.data = that.close_data;

            if (STANDARD_MODEL == true) updateMeshesStandard(result);
            else if (STANDARD_MODEL == false) updateMeshesAdvanced(result);

            // that.babylon.changeCameraTarget();
            that.executeAnimation(that.animation.stage, that.animation.stage - 1, 1);
            that.babylon.initLights();
          };
        })(that, params);
        var fail = (function (that) {
          return function (xhr, status, errorThrown) { };
        })(that);
        var always = (function (that) {
          return function () {
            that.working = 0;
            that.loading(false);
          };
        })(that);
        that.getModelData(data, success, fail, always);
      }
    },
    changeParams: function (params) {
      if (!loaded) {
        this.paramsStorage = params;
      } else {
        this.reloadStorage = params;
        this.loading(true);
        var that = this;
        if (!that.working) {
          that.working = 1;
          var data = params;
          var success = (function (that, params) {
            return function (result) {
              if (result.hasOwnProperty('stats') && result.stats == 'fail') return;
              that.close_data = result.close_data;
              that.meshes = result.meshes;
              that.cameraTarget = result.cameraTarget;
              Engine3DVariables.thickness = result.thickness;
              Engine3DVariables.cameraTarget = result.cameraTarget;
              thickness = parseFloat(result.thickness);
              Engine3DVariables.fluteType = result.fluteType;
              setFluteType(Engine3DVariables.fluteType);
              variables = result.variables;

              that.data = that.close_data;

              // that.importMeshes();

              if (params.outsideTexture) {
                var path = texturesUrl;
                if (!isProof) {
                  path += params.outsideTexture;
                } else {
                  path = params.outsideTexture;
                }
                var outsideMat = window.scene.getMaterialByName('BackMaterial');
                outsideMat.getBlockByName('baseMap').texture = new BABYLON.Texture(path, window.scene);
              }

              if (params.insideTexture) {
                var path = texturesUrl;
                path += params.insideTexture;
                var insideMat = window.scene.getMaterialByName('FaceMaterial');
                insideMat.getBlockByName('baseMap').texture = new BABYLON.Texture(path, window.scene);
              }

              if (STANDARD_MODEL == true) updateMeshesStandard(result);
              else if (STANDARD_MODEL == false) updateMeshesAdvanced(result);

              updateCamera();
              // that.babylon.changeCameraTarget();
              that.executeAnimation(that.animation.stage, that.animation.stage - 1, 1);
              that.babylon.initLights();
            };
          })(that, params);
          var fail = (function (that) {
            return function (xhr, status, errorThrown) { };
          })(that);
          var always = (function (that) {
            return function () {
              that.working = 0;
              that.loading(false);
            };
          })(that);
          that.getModelData(data, success, fail, always);
        }
      }
    },
    initAnimationButtons: function () {
      this.animationButtons.off('click').on(
        'click',
        (function (that) {
          return function () {
            var _self = $(this);
            if (_self.closest('.loading').length) return;
            var state = _self.data('state');
            that.changeAnimationState(state);
          };
        })(this)
      );
    },
    getModelData: function (data, success, fail, always) {
      data['return_type'] = 'json';
      $.ajax({
        url: Engine3DVariables.getDataUrl,
        data: data,
        type: 'POST',
        dataType: 'json',
      })
        .done(function (json) {
          if (typeof success == 'function') {
            cachedModelData = json;
            success(json);
          }
        })
        .fail(function (xhr, status, errorThrown) {
          if (typeof fail == 'function') fail(xhr, status, errorThrown);
        })
        .always(function (data) {
          if (typeof always == 'function') always(data);
        });
    },
  };

  var model = new Engine3D('#renderCanvas', '#modelSizeForm', Engine3DVariables);

  const initChangeModelDetails = function () {
    const container = $('#modelDetails');
    const checkboxElement = container.find('#modelDetailsOption');
    const highlightCheckbox = container.find('#highlightOption');
    const meshFocusCheckbox = container.find('#meshFocusOption');

    //on init
    if (highlightCheckbox.val() == '1') {
      enableHighlight = true;
    }
    if (meshFocusCheckbox.val() == '1') {
      enableMeshFocus = true;
    }

    highlightCheckbox.off('change').on('change', (event) => {
      const HVal = highlightCheckbox.prop('checked');
      enableHighlight = HVal;
      clearHighlight();
    });

    meshFocusCheckbox.off('change').on('change', (event) => {
      const HVal = meshFocusCheckbox.prop('checked');
      enableMeshFocus = HVal;
      clearHighlight();
    });

    checkboxElement.off('change').on('change', (event) => {
      const val = checkboxElement.prop('checked');
      STANDARD_MODEL = !val;
      model.reloadModel();
    });
  };
  var saveInitialCameraValues = function () {
    scene.activeCamera.storeState();
  };
  window.takeScreenshot = function (callback) {
    var changeSettings = function (callback) {
      model.executeAnimation(ssAttr.stage, 'init', 1);
      arcCamera.restoreState();
      scene.clearColor = ssAttr.bg;
      setTimeout(function () {
        callback();
      }, 100);
    };
    changeSettings(function () {
      BABYLON.Tools.CreateScreenshotUsingRenderTarget(
        scene._engine,
        scene.activeCamera,
        500,
        (function (callback) {
          return function (dataimage) {
            if (dataimage) {
              callback([dataimage]);
            } else {
              callback(null);
            }
          };
        })(callback)
      );
    });
  };

  window.addEventListener('DOMContentLoaded', function () {
    model.loadModel();
    initChangeModelDetails();
  });

  var OnMessage = function (e) {
    if (!loaded) {
      onMessageStorage = e.data;
    } else {
      if (e.data.length) {
        var _data = jQuery.parseJSON(e.data);
        if (_data.texture) {
          for (var j in _data.texture) {
            if (_data.texture[j][0].indexOf('.') >= 0) {
              var _tmpIndex = _data.texture[j][0].split('.');
              var material = scene.meshes[_tmpIndex[0]].material.subMaterials[_tmpIndex[1]];
            } else {
              var material = scene.meshes[_data.texture[j][0]].material;
            }
            if (typeof _data.lamination != 'undefined' && _data.lamination.length) {
              $.lamination = new Image();
              $.lamination.src = _data.lamination[0];
              $.lamination.onload = function () {
                var _rand = Math.random();
                var _time = Date.now();
                var x = new BABYLON.Texture(
                  'data:image_' + _rand + '_' + _time + 'jpeg', scene, undefined, undefined, undefined, function () {
                    material.getBlockByName('specularMap').texture = x;
                    material.getBlockByName('roughness_background').value = 1;
                    material.getBlockByName('ClearCoat_intensity').value = 0;
                    material.getBlockByName('Perturb normal').useObjectSpaceNormalMap = false

                    material.getBlockByName('letterpress_roughness_background').value = 1;
                    material.getBlockByName('letterpress_metallic_items').value = 0;
                    material.getBlockByName('letterpress_normalMap_intensity').value = 0;
                    material.getBlockByName('letterpress_metallic_background').value = 0.4;
                    material.getBlockByName('letterpress_letterpress_depth').value = 0.005;
                    material.getBlockByName('letterpress_roughness_items').value = 1;

                    material.getBlockByName('metallic_items').value = 0.6;
                    material.getBlockByName('normalMap_intensity').value = 5;
                    material.getBlockByName('metallic_background').value = 0.4;
                    material.getBlockByName('roughness_items').value = 0.4;
                  }, undefined, _data.lamination[0]);
              };
            } else {

              material.getBlockByName('letterpress_roughness_background').value = 1;
              material.getBlockByName('letterpress_metallic_items').value = 0;
              material.getBlockByName('letterpress_normalMap_intensity').value = 0;
              material.getBlockByName('letterpress_metallic_background').value = 0.4;
              material.getBlockByName('letterpress_roughness_items').value = 1;

              material.getBlockByName('ClearCoat_intensity').value = 0;
              material.getBlockByName('roughness_background').value = 1;
              material.getBlockByName('roughness_items').value = 1;
              material.getBlockByName('metallic_background').value = 0.4;
              material.getBlockByName('metallic_items').value = 0;
              material.getBlockByName('specularMap').texture = new BABYLON.Texture('../packing_textures/internal_black.jpg');
              material.getBlockByName('normalMap_intensity').value = 0;
              material.getBlockByName('Perturb normal').useObjectSpaceNormalMap = false
              window.parent.$('.btn_refresh_refinement_bump').removeClass('disabled');
            }
            if (typeof _data.bump != 'undefined' && _data.bump.length) {
              $.bump = new Image();
              $.bump.src = _data.bump[0];

              $.bump.onload = function () {
                var _rand = Math.random();
                var _time = Date.now();
                var x = new BABYLON.Texture(
                  'data:image_' + _rand + '_' + _time + 'jpeg',
                  window.scene, undefined, undefined, undefined, function () {
                    material.getBlockByName('normalMap').texture = x;
                    material.getBlockByName('normalMap_intensity').value = 5;
                    material.getBlockByName('ClearCoat_intensity').value = 0;
                  }, undefined, _data.bump[0]);
              };
            } else {
              material.getBlockByName('normalMap').texture = new BABYLON.Texture('../packing_textures/internal_normal.jpg');
              material.getBlockByName('normalMap_intensity').value = 0;
              material.getBlockByName('ClearCoat_intensity').value = 0;
            }
            if (typeof _data.image != 'undefined' && _data.image.length) {
              $.image = new Image();
              $.image.src = _data.image[_data.texture[j][1] - 1];
              $.image.onload = function () {
                var _rand = Math.random();
                var _time = Date.now();
                var blockName = 'baseMap';
                if (Engine3DVariables.multiplyArtwork == true) {
                  blockName = 'artworkMap';
                }
                var x = new BABYLON.Texture('data:image_' + _rand + '_' + _time + 'jpeg', window.scene, undefined, undefined, undefined, function () {
                  material.getBlockByName(blockName).texture = x;
                }, undefined, _data.image[_data.texture[j][1] - 1]);
              };
            }
          }
        }
        if (_data.changeDimension) {
          model.changeParams(_data.changeDimension);
        }
        if (_data.reloadModel) {
          model.reloadModel(_data.reloadModel);
        }
        if (_data.texture_upload) {
          if (_data.image.length == 0) {
            var insideDefault = 'karton.jpg';
            var outsideDefault = 'white.png';
            insideTexture = insideDefault;
            outsideTexture = outsideDefault;
            if (_data.infos_td && _data.infos_td.insideTexture) {
              insideTexture = _data.infos_td.insideTexture;
              Engine3DVariables.shouldLoadInitialTextures = true;
            }
            if (_data.infos_td && _data.infos_td.outsideTexture) {
              outsideTexture = _data.infos_td.outsideTexture;
              Engine3DVariables.shouldLoadInitialTextures = true;
            }

            Engine3DVariables.currentInsideTexture = texturesUrl + insideTexture;
            Engine3DVariables.currentOutsideTexture = texturesUrl + outsideTexture;
          }

          model.babylon.changeInitialTextureWithCallback(
            (function (_data) {
              return function () {
                if (!_data.image.length) {
                  return;
                }
                let textures = [];
                let whenAllReady = function (textures, resolve) {
                  let numRemaining = textures.length;
                  if (numRemaining == 0) {
                    resolve();
                    return;
                  }

                  for (let i = 0; i < textures.length; i++) {
                    let texture = textures[i];
                    if (texture.isReady()) {
                      if (--numRemaining === 0) {
                        resolve();
                        return;
                      }
                    } else {
                      let onLoadObservable = texture.onLoadObservable;
                      if (onLoadObservable) {
                        onLoadObservable.addOnce(() => {
                          if (--numRemaining === 0) {
                            resolve();
                          }
                        });
                      }
                    }
                  }
                };
                (() =>
                  new Promise((resolve, reject) => {
                    let textureUrls = _data.image;
                    for (let url of textureUrls) {
                      if (url.length !== 0) {
                        textures.push(new BABYLON.Texture(url, scene));
                      }
                    }
                    whenAllReady(textures, () => resolve(textures));
                  }).then(() => {
                    var blockName = 'baseMap';
                    if (Engine3DVariables.multiplyArtwork == true) {
                      blockName = 'artworkMap';
                    }
                    for (var j in _data.texture_upload) {
                      if (_data.texture_upload[j].indexOf('.') >= 0) {
                        if (_data.image[j - 1]) {
                          var _tmpIndex = _data.texture_upload[j].split('.');
                          scene.meshes[_tmpIndex[0]].material.subMaterials[_tmpIndex[1]].getBlockByName(blockName).texture = textures[j - 1];
                        }
                      } else {
                        if (_data.image[j - 1]) {
                          scene.meshes[_data.texture_upload[j]].getBlockByName(blockName).texture = textures[j - 1];
                        }
                      }
                    }
                  }))();
              };
            })(_data)
          );
        }
        if (_data.animation_click) {
          if (_data.animation_click == 'forward') {
            document.getElementById('AnimationClose').click();
          } else if (_data.animation_click == 'backward') {
            document.getElementById('AnimationOpen').click();
          }
        }
      }
    }
  };

  if (window.addEventListener) {
    // all browsers except IE before version 9
    window.addEventListener('message', OnMessage, false);
  } else {
    if (window.attachEvent) {
      // IE before version 9
      window.attachEvent('onmessage', OnMessage);
    }
  }
} else {
  document.body.classList.add('webGLDisabled');
}
